export const lstAtributos = [
    {
        titleHtml: "Dados da SPE",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_NOME@">NOME_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_NOME@",
                campo: "NOME_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CNPJ da SPE" value="@TB_CMCRM_PRODUTO.PAI.NR_SPE_CNPJ@">CNPJ_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.NR_SPE_CNPJ@",
                campo: "CNPJ_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Logradouro da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_LOGRADOURO@">LOGRADOURO_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_LOGRADOURO@",
                campo: "LOGRADOURO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço da SPE" value="@TB_CMCRM_PRODUTO.PAI.NR_SPE_NUMERO@">NUMERO_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.NR_SPE_NUMERO@",
                campo: "NUMERO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_BAIRRO@">BAIRRO_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_BAIRRO@",
                campo: "BAIRRO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_COMPLEMENTO@">COMPLEMENTO_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_COMPLEMENTO@",
                campo: "COMPLEMENTO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_CIDADE@">CIDADE_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_CIDADE@",
                campo: "CIDADE_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_ESTADO@">UF_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_ESTADO@",
                campo: "UF_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_CEP@">CEP_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_CEP@",
                campo: "CEP_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_TELEFONE@">TELEFONE_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_TELEFONE@",
                campo: "TELEFONE_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email da SPE" value="@TB_CMCRM_PRODUTO.PAI.DS_SPE_EMAIL@">EMAIL_SPE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_SPE_EMAIL@",
                campo: "EMAIL_SPE",
            },
        ],
    },
    {
        titleHtml: "Dados dos Usuários da SPE",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados dos Usuários da SPE" value="@UTIL.USUARIO_SPE.INICIO@">INICIO_USUARIOS_SPE</a>',
                parametro: "@UTIL.USUARIO_SPE.INICIO@",
                campo: "INICIO_USUARIOS_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados dos Usuários da SPE" value="@UTIL.USUARIO_SPE.FIM@">FIM_USUARIOS_SPE</a>',
                parametro: "@UTIL.USUARIO_SPE.FIM@",
                campo: "FIM_USUARIOS_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_NOME@">NOME_USUARIO_SPE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_NOME@",
                campo: "NOME_USUARIO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_CPF@">CPF/CNPJ_USUARIO_SPE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_CPF@",
                campo: "CPF/CNPJ_USUARIO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_RG_TIPO@">TIPO_REG</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_RG_TIPO@",
                campo: "TIPO_REG",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Registro do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.NR_RG@">REG</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.NR_RG@",
                campo: "REG",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do Registro do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_RG_ORGAO_EMISSOR@">RG_EMISSOR</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_RG_ORGAO_EMISSOR@",
                campo: "REG_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do Registro do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_RG_UF_EMISSOR@">REG_UF</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_RG_UF_EMISSOR@",
                campo: "REG_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do Registro do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DT_RG_EMISSAO@">REG_DATA</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DT_RG_EMISSAO@",
                campo: "REG_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DT_RG_VALIDADE@">REG_VALIDADE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DT_RG_VALIDADE@",
                campo: "REG_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_RG_CATEGORIA@">REG_CATEGORIA</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_RG_CATEGORIA@",
                campo: "REG_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_NACIONALIDADE@">NACIONALIDADE_USUARIO_SPE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_NACIONALIDADE@",
                campo: "NACIONALIDADE_USUARIO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado Civil do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_ESTADO_CIVIL@">ESTADO_CIVIL_USUARIO_SPE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL_USUARIO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_PROFISSAO@">PROFISSAO_USUARIO_SPE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_PROFISSAO@",
                campo: "PROFISSAO_USUARIO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.NR_ENDERECO@">NUMERO</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.NR_ENDERECO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO</a>',
                parametro:
                    "@TB_CMC_USUARIO.USUARIO_SPE.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_BAIRRO@">BAIRRO</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_BAIRRO@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.NR_CEP@">CEP</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.NR_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Usuário da SPE" value="@ASSINATURA.TB_CMC_USUARIO.USUARIO_SPE.ID_USUARIO@">ASSINATURA_USUARIO_SPE</a>',
                parametro: "@ASSINATURA.TB_CMC_USUARIO.USUARIO_SPE.ID_USUARIO@",
                campo: "ASSINATURA_USUARIO_SPE",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Usuário da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.DS_NOME_IMPORTACAO@">NOME_IMP_USUARIO_SPE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.DS_NOME_IMPORTACAO@",
                campo: "NOME_IMP_USUARIO_SPE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF/CNPJ de Importação do Usuario da SPE" value="@TB_CMC_USUARIO.USUARIO_SPE.NR_CPF_IMPORTACAO@">CPF_IMPORTACAO_USUARIO_SPE</a>',
                parametro: "@TB_CMC_USUARIO.USUARIO_SPE.NR_CPF_IMPORTACAO@",
                campo: "CPF_IMPORTACAO_USUARIO_SPE",
            },
        ],
    },
    {
        titleHtml: "Dados do Proponente",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início de Pessoa Física" value="@UTIL.PESSOA_FISICA.INICIO@">INICIO_PESSOA_FISICA</a>',
                parametro: "@UTIL.PESSOA_FISICA.INICIO@",
                campo: "INICIO_PESSOA_FISICA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim de Pessoa Física" value="@UTIL.PESSOA_FISICA.FIM@">FIM_PESSOA_FISICA</a>',
                parametro: "@UTIL.PESSOA_FISICA.FIM@",
                campo: "FIM_PESSOA_FISICA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início de Pessoa Jurídica" value="@UTIL.PESSOA_JURIDICA.INICIO@">INICIO_PESSOA_JURIDICA</a>',
                parametro: "@UTIL.PESSOA_JURIDICA.INICIO@",
                campo: "INICIO_PESSOA_JURIDICA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim de Pessoa Jurídica" value="@UTIL.PESSOA_JURIDICA.FIM@">FIM_PESSOA_JURIDICA</a>',
                parametro: "@UTIL.PESSOA_JURIDICA.FIM@",
                campo: "FIM_PESSOA_JURIDICA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_NOME@">NOME</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME@",
                campo: "NOME",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Razão Social do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_RAZAO_SOCIAL@">RAZAO_SOCIAL</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RAZAO_SOCIAL@",
                campo: "RAZAO_SOCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Inscrição Estadual do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_INSCRICAO_ESTADUAL@">INSCRICAO_ESTADUAL</a>',
                parametro: "@TB_CMCRM_CONTA.NR_INSCRICAO_ESTADUAL@",
                campo: "INSCRICAO_ESTADUAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Inscrição Municipal do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_INSCRICAO_MUNICIPAL@">INSCRICAO_MUNICIPAL</a>',
                parametro: "@TB_CMCRM_CONTA.NR_INSCRICAO_MUNICIPAL@",
                campo: "INSCRICAO_MUNICIPAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Registro de Junta do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_REGISTRO_JUNTA@">REGISTRO_JUNTA</a>',
                parametro: "@TB_CMCRM_CONTA.NR_REGISTRO_JUNTA@",
                campo: "REGISTRO_JUNTA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Pai do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_NOME_PAI@">NOME_PAI</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME_PAI@",
                campo: "NOME_PAI",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Mãe do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_NOME_MAE@">NOME_MAE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME_MAE@",
                campo: "NOME_MAE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_RG_TIPO@">TIPO_REG</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_TIPO@",
                campo: "TIPO_REG",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Registro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_RG@">REG</a>',
                parametro: "@TB_CMCRM_CONTA.NR_RG@",
                campo: "REG",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do Registro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_RG_ORGAO_EMISSOR@">RG_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_ORGAO_EMISSOR@",
                campo: "REG_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do Registro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_RG_UF_EMISSOR@">REG_UF</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_UF_EMISSOR@",
                campo: "REG_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do Registro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DT_RG_EMISSAO@">REG_DATA</a>',
                parametro: "@TB_CMCRM_CONTA.DT_RG_EMISSAO@",
                campo: "REG_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DT_RG_VALIDADE@">REG_VALIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DT_RG_VALIDADE@",
                campo: "REG_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_RG_CATEGORIA@">REG_CATEGORIA</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_CATEGORIA@",
                campo: "REG_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_CPF@">CPF/CNPJ</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CPF@",
                campo: "CPF/CNPJ",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DT_NASCIMENTO@">DT_NASCIMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_NASCIMENTO@",
                campo: "DT_NASCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone 1 do(s) Proponente(s)" value="@TB_CMCRM_CONTA.TELEFONE.NR_TELEFONE@">TELEFONE</a>',
                parametro: "@TB_CMCRM_CONTA.TELEFONE.NR_TELEFONE@",
                campo: "TELEFONE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone 2 do(s) Proponente(s)" value="@TB_CMCRM_CONTA.TELEFONE.NR_TELEFONE_2@">TELEFONE_2</a>',
                parametro: "@TB_CMCRM_CONTA.TELEFONE.NR_TELEFONE_2@",
                campo: "TELEFONE_2",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone Comercial do(s) Proponente(s)" value="@TB_CMCRM_CONTA.TELEFONE.NR_COMERCIAL@">NR_COMERCIAL</a>',
                parametro: "@TB_CMCRM_CONTA.TELEFONE.NR_COMERCIAL@",
                campo: "NR_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone Celular do(s) Proponente(s)" value="@TB_CMCRM_CONTA.TELEFONE.NR_CELULAR@">NR_CELULAR</a>',
                parametro: "@TB_CMCRM_CONTA.TELEFONE.NR_CELULAR@",
                campo: "NR_CELULAR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone Residencial do(s) Proponente(s)" value="@TB_CMCRM_CONTA.TELEFONE.NR_RESIDENCIAL@">NR_RESIDENCIAL</a>',
                parametro: "@TB_CMCRM_CONTA.TELEFONE.NR_RESIDENCIAL@",
                campo: "NR_RESIDENCIAL",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo do Telefone" value="@TB_CMCRM_CONTA.TELEFONE.DS_TIPO_TELEFONE@">TIPO_TEL</a>',
                parametro: "@TB_CMCRM_CONTA.TELEFONE.DS_TIPO_TELEFONE@",
                campo: "TIPO_TEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_EMAIL@">EMAIL</a>',
                parametro: "@TB_CMCRM_CONTA.DS_EMAIL@",
                campo: "EMAIL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado Civil do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_ESTADO_CIVIL@">ESTADO_CIVIL</a>',
                parametro: "@TB_CMCRM_CONTA.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_NACIONALIDADE@">NACIONALIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NACIONALIDADE@",
                campo: "NACIONALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_NATURALIDADE@">NATURALIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NATURALIDADE@",
                campo: "NATURALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Admissão do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DT_ADMISSAO@">DATA_ADMISSAO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_ADMISSAO@",
                campo: "DATA_ADMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_PROFISSAO_CONTA@">PROFISSAO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_PROFISSAO_CONTA@",
                campo: "PROFISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Grau de Escolaridade do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_ESCOLARIDADE@">ESCOLARIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_ESCOLARIDADE@",
                campo: "ESCOLARIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tempo de Residência do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_TEMPO_RESIDENCIA@">TEMPO_RESIDENCIA</a>',
                parametro: "@TB_CMCRM_CONTA.DS_TEMPO_RESIDENCIA@",
                campo: "TEMPO_RESIDENCIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Porcentagem (%) de Participação do(s) Proponente(s)" value="@TB_CMCRM_CONTA.VL_PARTICIPACAO@">%_PARTICIPACAO</a>',
                parametro: "@TB_CMCRM_CONTA.VL_PARTICIPACAO@",
                campo: "%_PARTICIPACAO",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_LOGRADOURO_COBRANCA@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_LOGRADOURO_COBRANCA@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_ENDERECO_COBRANCA@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTA.NR_ENDERECO_COBRANCA@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_COMPLEMENTO_COBRANCA@">COMPLEMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_COMPLEMENTO_COBRANCA@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_BAIRRO_COBRANCA@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_BAIRRO_COBRANCA@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_CIDADE_COBRANCA@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_CIDADE_COBRANCA@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_ESTADO_COBRANCA@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_ESTADO_COBRANCA@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_CEP_COBRANCA@">CEP</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CEP_COBRANCA@",
                campo: "CEP",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_LOGRADOURO_ENTREGA@">ENDERECO_ENTREGA</a>',
                parametro: "@TB_CMCRM_CONTA.DS_LOGRADOURO_ENTREGA@",
                campo: "ENDERECO_ENTREGA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_ENDERECO_ENTREGA@">NUMERO_ENTREGA</a>',
                parametro: "@TB_CMCRM_CONTA.NR_ENDERECO_ENTREGA@",
                campo: "NUMERO_ENTREGA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_COMPLEMENTO_ENTREGA@">COMPLEMENTO_ENTREGA</a>',
                parametro: "@TB_CMCRM_CONTA.DS_COMPLEMENTO_ENTREGA@",
                campo: "COMPLEMENTO_ENTREGA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_BAIRRO_ENTREGA@">BAIRRO_ENTREGA</a>',
                parametro: "@TB_CMCRM_CONTA.DS_BAIRRO_ENTREGA@",
                campo: "BAIRRO_ENTREGA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_CIDADE_ENTREGA@">CIDADE_ENTREGA</a>',
                parametro: "@TB_CMCRM_CONTA.DS_CIDADE_ENTREGA@",
                campo: "CIDADE_ENTREGA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_ESTADO_ENTREGA@">ESTADO_ENTREGA</a>',
                parametro: "@TB_CMCRM_CONTA.DS_ESTADO_ENTREGA@",
                campo: "ESTADO_ENTREGA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_CEP_ENTREGA@">CEP_ENTREGA</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CEP_ENTREGA@",
                campo: "CEP_ENTREGA",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Salário do(s) Proponente(s)" value="@TB_CMCRM_CONTA.VL_RENDA@">SALÁRIO</a>',
                parametro: "@TB_CMCRM_CONTA.VL_RENDA@",
                campo: "VL_RENDA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Empresa em que trabalha o(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_EMPRESA_EMPREGADORA@">EMPRESA_EMPREGADORA</a>',
                parametro: "@TB_CMCRM_CONTA.DS_EMPRESA_EMPREGADORA@",
                campo: "DS_EMPRESA_EMPREGADORA",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Banco do(s) Proponente(s)" value="@TB_CMCRM_CONTA.ID_BANCO@">NUM_BANCO</a>',
                parametro: "@TB_CMCRM_CONTA.ID_BANCO@",
                campo: "ID_BANCO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Banco do(s) Proponente(s)" value="@TB_CMCRM_CONTA.DS_BANCO@">BANCO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_BANCO@",
                campo: "DS_BANCO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Agência do Banco do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_AGENCIA_BANCO@">AGENCIA_BANCO</a>',
                parametro: "@TB_CMCRM_CONTA.NR_AGENCIA_BANCO@",
                campo: "NR_AGENCIA_BANCO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Conta do Banco do(s) Proponente(s)" value="@TB_CMCRM_CONTA.NR_CONTA_BANCO@">CONTA_BANCO</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CONTA_BANCO@",
                campo: "NR_CONTA_BANCO",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Proponente" value="@ASSINATURA.TB_CMCRM_CONTA.ID_CONTA@">ASSINATURA</a>',
                parametro: "@ASSINATURA.TB_CMCRM_CONTA.ID_CONTA@",
                campo: "ASSINATURA",
            },
        ],
    },
    {
        titleHtml: "Dados do Cônjuge",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Cônjuge" value="@UTIL.CONJUGE.INICIO@">INICIO_CONJUGE</a>',
                parametro: "@UTIL.CONJUGE.INICIO@",
                campo: "INICIO_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Cônjuge" value="@UTIL.CONJUGE.FIM@">FIM_CONJUGE</a>',
                parametro: "@UTIL.CONJUGE.FIM@",
                campo: "FIM_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_NOME@">NOME_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_NOME@",
                campo: "NOME_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DT_NASCIMENTO@">DT_NASCIMENTO</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DT_NASCIMENTO@",
                campo: "DT_NASCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Regime de Comunhão" value="@TB_CMCRM_CONTA.DS_REGIME_COMUNHAO@">REGIME_COMUNHAO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_REGIME_COMUNHAO@",
                campo: "REGIME_COMUNHAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Casamento" value="@TB_CMCRM_CONTA.DT_CASAMENTO@">DT_CASAMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_CASAMENTO@",
                campo: "DT_CASAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Pai do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_NOME_PAI@">NOME_PAI_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_NOME_PAI@",
                campo: "NOME_PAI_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Mãe do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_NOME_MAE@">NOME_MAE_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_NOME_MAE@",
                campo: "NOME_MAE_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_RG_TIPO@">TIPO_REG_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_RG_TIPO@",
                campo: "TIPO_REG_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Registro do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.NR_RG@">REG_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.NR_RG@",
                campo: "REG_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do Registro do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_RG_ORGAO_EMISSOR@">REG_CONJUGE_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_RG_ORGAO_EMISSOR@",
                campo: "REG_CONJUGE_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do Registro do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_RG_UF_EMISSOR@">REG_CONJUGE_UF</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_RG_UF_EMISSOR@",
                campo: "REG_CONJUGE_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do Registro do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DT_RG_EMISSAO@">REG_CONJUGE_DATA</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DT_RG_EMISSAO@",
                campo: "REG_CONJUGE_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DT_RG_VALIDADE@">REG_CONJUGE_VALIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DT_RG_VALIDADE@",
                campo: "REG_CONJUGE_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_RG_CATEGORIA@">REG_CONJUGE_CATEGORIA</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_RG_CATEGORIA@",
                campo: "REG_CONJUGE_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.NR_CPF@">CPF/CNPJ_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.NR_CPF@",
                campo: "CPF/CNPJ_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_EMAIL@">EMAIL_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_EMAIL@",
                campo: "EMAIL_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.NR_TELEFONE@">TELEFONE_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.NR_TELEFONE@",
                campo: "TELEFONE_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_NACIONALIDADE@">NACIONAL_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_NACIONALIDADE@",
                campo: "NACIONAL_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_NATURALIDADE@">NATURALIDADE_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_NATURALIDADE@",
                campo: "NATURALIDADE_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Cônjuge" value="@TB_CMCRM_CONTATO.CONJUGE.DS_PROFISSAO@">PROFISSAO_CONJUGE</a>',
                parametro: "@TB_CMCRM_CONTATO.CONJUGE.DS_PROFISSAO@",
                campo: "PROFISSAO_CONJUGE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Cônjuge" value="@ASSINATURA.TB_CMCRM_CONTATO.CONJUGE.ID_CONTATO@">ASSINATURA_CONJUGE</a>',
                parametro: "@ASSINATURA.TB_CMCRM_CONTATO.CONJUGE.ID_CONTATO@",
                campo: "ASSINATURA_CONJUGE",
            },
        ],
    },
    {
        titleHtml: "Dados do Pacto Antenupcial",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Pacto Antenupcial" value="@UTIL.PACTOANTENUPCIAL.INICIO@">INICIO_PACTO</a>',
                parametro: "@UTIL.PACTOANTENUPCIAL.INICIO@",
                campo: "INICIO_PACTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Pacto Antenupcial" value="@UTIL.PACTOANTENUPCIAL.FIM@">FIM_PACTO</a>',
                parametro: "@UTIL.PACTOANTENUPCIAL.FIM@",
                campo: "FIM_PACTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Regime de Comunhão" value="@TB_CMCRM_CONTA.DS_REGIME_COMUNHAO@">REGIME_COMUNHAO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_REGIME_COMUNHAO@",
                campo: "REGIME_COMUNHAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Casamento" value="@TB_CMCRM_CONTA.DT_CASAMENTO@">DT_CASAMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_CASAMENTO@",
                campo: "DT_CASAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Existência de Pacto Antenupcial" value="@TB_CMCRM_CONTA.FL_PACTO_ANTE_NUPCIAL@">FL_PACTO_ANTENUPCIAL</a>',
                parametro: "@TB_CMCRM_CONTA.FL_PACTO_ANTE_NUPCIAL@",
                campo: "FL_PACTO_ANTENUPCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Informações do Pacto Antenupcial" value="@TB_CMCRM_CONTA.DS_PACTO_ANTE_NUPCIAL@">DS_PACTO_ANTE_NUPCIAL</a>',
                parametro: "@TB_CMCRM_CONTA.DS_PACTO_ANTE_NUPCIAL@",
                campo: "DS_PACTO_ANTE_NUPCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Início do Pacto Antenupcial" value="@TB_CMCRM_CONTA.DT_INICIO_ANTENUPCIAL@">DT_INICIO_PACTO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_INICIO_ANTENUPCIAL@",
                campo: "DT_INICIO_PACTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Fim do Pacto Antenupcial" value="@TB_CMCRM_CONTA.DT_FIM_ANTENUPCIAL@">DT_FIM_PACTO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_FIM_ANTENUPCIAL@",
                campo: "DT_FIM_PACTO",
            },
        ],
    },
    {
        titleHtml: "Dados do Fiador",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Fiador" value="@UTIL.FIADOR.INICIO@">INICIO_FIADOR</a>',
                parametro: "@UTIL.FIADOR.INICIO@",
                campo: "INICIO_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Fiador" value="@UTIL.FIADOR.FIM@">FIM_FIADOR</a>',
                parametro: "@UTIL.FIADOR.FIM@",
                campo: "FIM_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_NOME@">NOME_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_NOME@",
                campo: "NOME_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DT_NASCIMENTO@">DT_NASCIMENTO_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DT_NASCIMENTO@",
                campo: "DT_NASCIMENTO_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Pai do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_NOME_PAI@">NOME_PAI_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_NOME_PAI@",
                campo: "NOME_PAI_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Mãe do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_NOME_MAE@">NOME_MAE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_NOME_MAE@",
                campo: "NOME_MAE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_RG_TIPO@">TIPO_REG_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.TIPO_REG_FIADOR@",
                campo: "TIPO_REG_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Registro do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.NR_RG@">RG_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.NR_RG@",
                campo: "RG_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do Registro do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_RG_ORGAO_EMISSOR@">RG_FIADOR_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_RG_ORGAO_EMISSOR@",
                campo: "RG_FIADOR_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do Registro do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_RG_UF_EMISSOR@">RG_FIADOR_UF</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_RG_UF_EMISSOR@",
                campo: "RG_FIADOR_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do Registro do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DT_RG_EMISSAO@">RG_FIADOR_DATA</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DT_RG_EMISSAO@",
                campo: "RG_FIADOR_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DT_RG_VALIDADE@">REG_FIADOR_VALIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DT_RG_VALIDADE@",
                campo: "REG_FIADOR_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_RG_CATEGORIA@">REG_FIADOR_CATEGORIA</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_RG_CATEGORIA@",
                campo: "REG_FIADOR_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.NR_CPF@">CPF/CNPJ_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.NR_CPF@",
                campo: "CPF/CNPJ_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_EMAIL@">EMAIL_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_EMAIL@",
                campo: "EMAIL_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.NR_TELEFONE@">TELEFONE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.NR_TELEFONE@",
                campo: "TELEFONE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_NACIONALIDADE@">NACIONAL_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_NACIONALIDADE@",
                campo: "NACIONAL_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_NATURALIDADE@">NATURALIDADE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_NATURALIDADE@",
                campo: "NATURALIDADE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_PROFISSAO@">PROFISSAO_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_PROFISSAO@",
                campo: "PROFISSAO_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado Civil do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_ESTADO_CIVIL@">ESTADO_CIVIL_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Regime de Comunhão do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_REGIME_COMUNHAO@">REGIME_COMUNHAO_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_REGIME_COMUNHAO@",
                campo: "REGIME_COMUNHAO_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_NOME_CONJUGE@">NOME_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_NOME_CONJUGE@",
                campo: "NOME_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_EMAIL_CONJUGE@">EMAIL_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_EMAIL_CONJUGE@",
                campo: "EMAIL_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.NR_TELEFONE_CONJUGE@">TELEFONE_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.NR_TELEFONE_CONJUGE@",
                campo: "TELEFONE_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.NR_CPF_CONJUGE@">CPF_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.NR_CPF_CONJUGE@",
                campo: "CPF_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.NR_RG_CONJUGE@">RG_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.NR_RG_CONJUGE@",
                campo: "RG_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_RG_ORGAO_EMISSOR_CONJUGE@">RG_EMISSOR_CONJUGE_FIADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.FIADOR.DS_RG_ORGAO_EMISSOR_CONJUGE@",
                campo: "RG_EMISSOR_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_RG_UF_EMISSOR_CONJUGE@">RG_UF_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_RG_UF_EMISSOR_CONJUGE@",
                campo: "RG_UF_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DT_RG_EMISSAO_CONJUGE@">RG_DATA_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DT_RG_EMISSAO_CONJUGE@",
                campo: "RG_DATA_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo do RG do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_RG_TIPO_CONJUGE@">RG_TIPO_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_RG_TIPO_CONJUGE@",
                campo: "RG_TIPO_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do RG do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_RG_CATEGORIA_CONJUGE@">RG_CATEGORIA_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_RG_CATEGORIA_CONJUGE@",
                campo: "RG_CATEGORIA_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Validade do RG do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DT_RG_VALIDADE_CONJUGE@">RG_VALIDADE_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DT_RG_VALIDADE_CONJUGE@",
                campo: "RG_VALIDADE_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DT_NASCIMENTO_CONJUGE@">NASCIMENTO_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DT_NASCIMENTO_CONJUGE@",
                campo: "NASCIMENTO_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_NACIONALIDADE_CONJUGE@">NACIONALIDADE_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_NACIONALIDADE_CONJUGE@",
                campo: "NACIONALIDADE_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_NATURALIDADE_CONJUGE@">NATURALIDADE_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_NATURALIDADE_CONJUGE@",
                campo: "NATURALIDADE_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Cônjuge do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_PROFISSAO_CONJUGE@">PROFISSAO_CONJUGE_FIADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_PROFISSAO_CONJUGE@",
                campo: "PROFISSAO_CONJUGE_FIADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.NR_ENDERECO@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.NR_ENDERECO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_BAIRRO@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_BAIRRO@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Fiador" value="@TB_CMCRM_CONTATO.FIADOR.NR_CEP@">CEP</a>',
                parametro: "@TB_CMCRM_CONTATO.FIADOR.NR_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Fiador" value="@ASSINATURA.TB_CMCRM_CONTATO.FIADOR.ID_CONTATO@">ASSINATURA_FIADOR</a>',
                parametro: "@ASSINATURA.TB_CMCRM_CONTATO.FIADOR.ID_CONTATO@",
                campo: "ASSINATURA_FIADOR",
            },
        ],
    },
    {
        titleHtml: "Dados do Sócio",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Sócio" value="@UTIL.SOCIO.INICIO@">INICIO_SOCIO</a>',
                parametro: "@UTIL.SOCIO.INICIO@",
                campo: "INICIO_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Sócio" value="@UTIL.SOCIO.FIM@">FIM_SOCIO</a>',
                parametro: "@UTIL.SOCIO.FIM@",
                campo: "FIM_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_NOME@">NOME_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_NOME@",
                campo: "NOME_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Pai do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_NOME_PAI@">NOME_PAI_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_NOME_PAI@",
                campo: "NOME_PAI_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Mãe do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_NOME_MAE@">NOME_MAE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_NOME_MAE@",
                campo: "NOME_MAE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_RG_TIPO@">TIPO_REG_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.TIPO_REG_SOCIO@",
                campo: "TIPO_REG_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.NR_RG@">RG_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.NR_RG@",
                campo: "RG_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_RG_ORGAO_EMISSOR@">RG_SOCIO_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_RG_ORGAO_EMISSOR@",
                campo: "RG_SOCIO_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_RG_UF_EMISSOR@">RG_SOCIO_UF</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_RG_UF_EMISSOR@",
                campo: "RG_SOCIO_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DT_RG_EMISSAO@">RG_SOCIO_DATA</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DT_RG_EMISSAO@",
                campo: "RG_SOCIO_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DT_RG_VALIDADE@">REG_SOCIO_VALIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DT_RG_VALIDADE@",
                campo: "REG_SOCIO_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_RG_CATEGORIA@">REG_SOCIO_CATEGORIA</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_RG_CATEGORIA@",
                campo: "REG_SOCIO_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.NR_CPF@">CPF/CNPJ_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.NR_CPF@",
                campo: "CPF/CNPJ_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.NR_TELEFONE@">TELEFONE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.NR_TELEFONE@",
                campo: "TELEFONE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_NACIONALIDADE@">NACIONAL_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_NACIONALIDADE@",
                campo: "NACIONAL_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_NATURALIDADE@">NATURALIDADE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_NATURALIDADE@",
                campo: "NATURALIDADE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_PROFISSAO@">PROFISSAO_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_PROFISSAO@",
                campo: "PROFISSAO_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado Civil do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_ESTADO_CIVIL@">ESTADO_CIVIL_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Regime de Comunhão do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_REGIME_COMUNHAO@">REGIME_COMUNHAO_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_REGIME_COMUNHAO@",
                campo: "REGIME_COMUNHAO_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_NOME_CONJUGE@">NOME_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_NOME_CONJUGE@",
                campo: "NOME_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_EMAIL_CONJUGE@">EMAIL_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_EMAIL_CONJUGE@",
                campo: "EMAIL_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email  do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_EMAIL@">EMAIL_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_EMAIL@",
                campo: "EMAIL_SOCIO",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.NR_TELEFONE_CONJUGE@">TELEFONE_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.NR_TELEFONE_CONJUGE@",
                campo: "TELEFONE_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.NR_CPF_CONJUGE@">CPF_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.NR_CPF_CONJUGE@",
                campo: "CPF_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.NR_RG_CONJUGE@">RG_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.NR_RG_CONJUGE@",
                campo: "RG_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_RG_ORGAO_EMISSOR_CONJUGE@">RG_EMISSOR_CONJUGE_SOCIO</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.SOCIO.DS_RG_ORGAO_EMISSOR_CONJUGE@",
                campo: "RG_EMISSOR_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_RG_UF_EMISSOR_CONJUGE@">RG_UF_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_RG_UF_EMISSOR_CONJUGE@",
                campo: "RG_UF_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DT_RG_EMISSAO_CONJUGE@">RG_DATA_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DT_RG_EMISSAO_CONJUGE@",
                campo: "RG_DATA_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo do RG do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_RG_TIPO_CONJUGE@">RG_TIPO_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_RG_TIPO_CONJUGE@",
                campo: "RG_TIPO_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do RG do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_RG_CATEGORIA_CONJUGE@">RG_CATEGORIA_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_RG_CATEGORIA_CONJUGE@",
                campo: "RG_CATEGORIA_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Validade do RG do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DT_RG_VALIDADE_CONJUGE@">RG_VALIDADE_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DT_RG_VALIDADE_CONJUGE@",
                campo: "RG_VALIDADE_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DT_NASCIMENTO_CONJUGE@">NASCIMENTO_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DT_NASCIMENTO_CONJUGE@",
                campo: "NASCIMENTO_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_NACIONALIDADE_CONJUGE@">NACIONALIDADE_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_NACIONALIDADE_CONJUGE@",
                campo: "NACIONALIDADE_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_NATURALIDADE_CONJUGE@">NATURALIDADE_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_NATURALIDADE_CONJUGE@",
                campo: "NATURALIDADE_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Cônjuge do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_PROFISSAO_CONJUGE@">PROFISSAO_CONJUGE_SOCIO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_PROFISSAO_CONJUGE@",
                campo: "PROFISSAO_CONJUGE_SOCIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.NR_ENDERECO@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.NR_ENDERECO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_BAIRRO@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_BAIRRO@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Sócio" value="@TB_CMCRM_CONTATO.SOCIO.NR_CEP@">CEP</a>',
                parametro: "@TB_CMCRM_CONTATO.SOCIO.NR_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Sócio" value="@ASSINATURA.TB_CMCRM_CONTATO.SOCIO.ID_CONTATO@">ASSINATURA_SOCIO</a>',
                parametro: "@ASSINATURA.TB_CMCRM_CONTATO.SOCIO.ID_CONTATO@",
                campo: "ASSINATURA_SOCIO",
            },
        ],
    },
    {
        titleHtml: "Dados do Procurador",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Procurador" value="@UTIL.PROCURADOR.INICIO@">INICIO_PROCURADOR</a>',
                parametro: "@UTIL.PROCURADOR.INICIO@",
                campo: "INICIO_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Procurador" value="@UTIL.PROCURADOR.FIM@">FIM_PROCURADOR</a>',
                parametro: "@UTIL.PROCURADOR.FIM@",
                campo: "FIM_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_NOME@">NOME_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_NOME@",
                campo: "NOME_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Pai do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_NOME_PAI@">NOME_PAI_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_NOME_PAI@",
                campo: "NOME_PAI_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Mãe do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_NOME_MAE@">NOME_MAE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_NOME_MAE@",
                campo: "NOME_MAE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_TIPO@">TIPO_REG_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.TIPO_REG_PROCURADOR@",
                campo: "TIPO_REG_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.NR_RG@">RG_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.NR_RG@",
                campo: "RG_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_ORGAO_EMISSOR@">RG_PROCURADOR_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_ORGAO_EMISSOR@",
                campo: "RG_PROCURADOR_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_UF_EMISSOR@">RG_PROCURADOR_UF</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_UF_EMISSOR@",
                campo: "RG_PROCURADOR_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DT_RG_EMISSAO@">RG_PROCURADOR_DATA</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DT_RG_EMISSAO@",
                campo: "RG_PROCURADOR_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DT_RG_VALIDADE@">REG_PROCURADOR_VALIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DT_RG_VALIDADE@",
                campo: "REG_PROCURADOR_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_CATEGORIA@">REG_PROCURADOR_CATEGORIA</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_CATEGORIA@",
                campo: "REG_PROCURADOR_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.NR_CPF@">CPF/CNPJ_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.NR_CPF@",
                campo: "CPF/CNPJ_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.NR_TELEFONE@">TELEFONE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.NR_TELEFONE@",
                campo: "TELEFONE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_NACIONALIDADE@">NACIONAL_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_NACIONALIDADE@",
                campo: "NACIONAL_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_NATURALIDADE@">NATURALIDADE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_NATURALIDADE@",
                campo: "NATURALIDADE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_PROFISSAO@">PROFISSAO_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_PROFISSAO@",
                campo: "PROFISSAO_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado Civil do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_ESTADO_CIVIL@">ESTADO_CIVIL_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Regime de Comunhão do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_REGIME_COMUNHAO@">REGIME_COMUNHAO_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_REGIME_COMUNHAO@",
                campo: "REGIME_COMUNHAO_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_NOME_CONJUGE@">NOME_CONJUGE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_NOME_CONJUGE@",
                campo: "NOME_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_EMAIL_CONJUGEDS_EMAIL_CONJUGE@">EMAIL_CONJUGE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_EMAIL_CONJUGE@",
                campo: "EMAIL_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_EMAIL@">EMAIL_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_EMAIL@",
                campo: "EMAIL_PROCURADOR",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.NR_TELEFONE_CONJUGE@">TELEFONE_CONJUGE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.NR_TELEFONE_CONJUGE@",
                campo: "TELEFONE_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.NR_CPF_CONJUGE@">CPF_CONJUGE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.NR_CPF_CONJUGE@",
                campo: "CPF_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.NR_RG_CONJUGE@">RG_CONJUGE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.NR_RG_CONJUGE@",
                campo: "RG_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_ORGAO_EMISSOR_CONJUGE@">RG_EMISSOR_CONJUGE_PROCURADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_ORGAO_EMISSOR_CONJUGE@",
                campo: "RG_EMISSOR_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_UF_EMISSOR_CONJUGE@">RG_UF_CONJUGE_PROCURADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_UF_EMISSOR_CONJUGE@",
                campo: "RG_UF_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DT_RG_EMISSAO_CONJUGE@">RG_DATA_CONJUGE_PROCURADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DT_RG_EMISSAO_CONJUGE@",
                campo: "RG_DATA_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo do RG do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_TIPO_CONJUGE@">RG_TIPO_CONJUGE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_TIPO_CONJUGE@",
                campo: "RG_TIPO_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do RG do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_CATEGORIA_CONJUGE@">RG_CATEGORIA_CONJUGE_PROCURADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DS_RG_CATEGORIA_CONJUGE@",
                campo: "RG_CATEGORIA_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Validade do RG do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DT_RG_VALIDADE_CONJUGE@">RG_VALIDADE_CONJUGE_PROCURADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DT_RG_VALIDADE_CONJUGE@",
                campo: "RG_VALIDADE_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DT_NASCIMENTO_CONJUGE@">NASCIMENTO_CONJUGE_PROCURADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DT_NASCIMENTO_CONJUGE@",
                campo: "NASCIMENTO_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_NACIONALIDADE_CONJUGE@">NACIONALIDADE_CONJUGE_PROCURADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DS_NACIONALIDADE_CONJUGE@",
                campo: "NACIONALIDADE_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_NATURALIDADE_CONJUGE@">NATURALIDADE_CONJUGE_PROCURADOR</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DS_NATURALIDADE_CONJUGE@",
                campo: "NATURALIDADE_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Cônjuge do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_PROFISSAO_CONJUGE@">PROFISSAO_CONJUGE_PROCURADOR</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_PROFISSAO_CONJUGE@",
                campo: "PROFISSAO_CONJUGE_PROCURADOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.NR_ENDERECO@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.NR_ENDERECO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.PROCURADOR.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_BAIRRO@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_BAIRRO@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Procurador" value="@TB_CMCRM_CONTATO.PROCURADOR.NR_CEP@">CEP</a>',
                parametro: "@TB_CMCRM_CONTATO.PROCURADOR.NR_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Procurador" value="@ASSINATURA.TB_CMCRM_CONTATO.PROCURADOR.ID_CONTATO@">ASSINATURA_PROCURADOR</a>',
                parametro:
                    "@ASSINATURA.TB_CMCRM_CONTATO.PROCURADOR.ID_CONTATO@",
                campo: "ASSINATURA_PROCURADOR",
            },
        ],
    },
    {
        titleHtml: "Dados da Testemunha",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados da Testemunha" value="@UTIL.TESTEMUNHA.INICIO@">INICIO_TESTEMUNHA</a>',
                parametro: "@UTIL.TESTEMUNHA.INICIO@",
                campo: "INICIO_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados da Testemunha" value="@UTIL.TESTEMUNHA.FIM@">FIM_TESTEMUNHA</a>',
                parametro: "@UTIL.TESTEMUNHA.FIM@",
                campo: "FIM_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NOME@">NOME_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NOME@",
                campo: "NOME_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Pai da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NOME_PAI@">NOME_PAI_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NOME_PAI@",
                campo: "NOME_PAI_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Mãe da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NOME_MAE@">NOME_MAE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NOME_MAE@",
                campo: "NOME_MAE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_TIPO@">TIPO_REG_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.TIPO_REG_TESTEMUNHA@",
                campo: "TIPO_REG_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.NR_RG@">RG_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.NR_RG@",
                campo: "RG_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_ORGAO_EMISSOR@">RG_TESTEMUNHA_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_ORGAO_EMISSOR@",
                campo: "RG_TESTEMUNHA_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_UF_EMISSOR@">RG_TESTEMUNHA_UF</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_UF_EMISSOR@",
                campo: "RG_TESTEMUNHA_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DT_RG_EMISSAO@">RG_TESTEMUNHA_DATA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DT_RG_EMISSAO@",
                campo: "RG_TESTEMUNHA_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DT_RG_VALIDADE@">REG_TESTEMUNHA_VALIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DT_RG_VALIDADE@",
                campo: "REG_TESTEMUNHA_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_CATEGORIA@">REG_TESTEMUNHA_CATEGORIA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_CATEGORIA@",
                campo: "REG_TESTEMUNHA_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.NR_CPF@">CPF/CNPJ_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.NR_CPF@",
                campo: "CPF/CNPJ_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.NR_TELEFONE@">TELEFONE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.NR_TELEFONE@",
                campo: "TELEFONE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NACIONALIDADE@">NACIONAL_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NACIONALIDADE@",
                campo: "NACIONAL_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NATURALIDADE@">NATURALIDADE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NATURALIDADE@",
                campo: "NATURALIDADE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_PROFISSAO@">PROFISSAO_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_PROFISSAO@",
                campo: "PROFISSAO_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado Civil da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_ESTADO_CIVIL@">ESTADO_CIVIL_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Regime de Comunhão da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_REGIME_COMUNHAO@">REGIME_COMUNHAO_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_REGIME_COMUNHAO@",
                campo: "REGIME_COMUNHAO_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NOME_CONJUGE@">NOME_CONJUGE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NOME_CONJUGE@",
                campo: "NOME_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_EMAIL_CONJUGEDS_EMAIL_CONJUGE@">EMAIL_CONJUGE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_EMAIL_CONJUGE@",
                campo: "EMAIL_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_EMAIL@">EMAIL_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_EMAIL@",
                campo: "EMAIL_TESTEMUNHA",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.NR_TELEFONE_CONJUGE@">TELEFONE_CONJUGE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.NR_TELEFONE_CONJUGE@",
                campo: "TELEFONE_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.NR_CPF_CONJUGE@">CPF_CONJUGE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.NR_CPF_CONJUGE@",
                campo: "CPF_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.NR_RG_CONJUGE@">RG_CONJUGE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.NR_RG_CONJUGE@",
                campo: "RG_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_ORGAO_EMISSOR_CONJUGE@">RG_EMISSOR_CONJUGE_TESTEMUNHA</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_ORGAO_EMISSOR_CONJUGE@",
                campo: "RG_EMISSOR_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_UF_EMISSOR_CONJUGE@">RG_UF_CONJUGE_TESTEMUNHA</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_UF_EMISSOR_CONJUGE@",
                campo: "RG_UF_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DT_RG_EMISSAO_CONJUGE@">RG_DATA_CONJUGE_TESTEMUNHA</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DT_RG_EMISSAO_CONJUGE@",
                campo: "RG_DATA_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo do RG do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_TIPO_CONJUGE@">RG_TIPO_CONJUGE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_TIPO_CONJUGE@",
                campo: "RG_TIPO_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do RG do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_CATEGORIA_CONJUGE@">RG_CATEGORIA_CONJUGE_TESTEMUNHA</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_RG_CATEGORIA_CONJUGE@",
                campo: "RG_CATEGORIA_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Validade do RG do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DT_RG_VALIDADE_CONJUGE@">RG_VALIDADE_CONJUGE_TESTEMUNHA</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DT_RG_VALIDADE_CONJUGE@",
                campo: "RG_VALIDADE_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DT_NASCIMENTO_CONJUGE@">NASCIMENTO_CONJUGE_TESTEMUNHA</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DT_NASCIMENTO_CONJUGE@",
                campo: "NASCIMENTO_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NACIONALIDADE_CONJUGE@">NACIONALIDADE_CONJUGE_TESTEMUNHA</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NACIONALIDADE_CONJUGE@",
                campo: "NACIONALIDADE_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NATURALIDADE_CONJUGE@">NATURALIDADE_CONJUGE_TESTEMUNHA</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_NATURALIDADE_CONJUGE@",
                campo: "NATURALIDADE_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Cônjuge da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_PROFISSAO_CONJUGE@">PROFISSAO_CONJUGE_TESTEMUNHA</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_PROFISSAO_CONJUGE@",
                campo: "PROFISSAO_CONJUGE_TESTEMUNHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.NR_ENDERECO@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.NR_ENDERECO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_BAIRRO@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_BAIRRO@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP da Testemunha" value="@TB_CMCRM_CONTATO.TESTEMUNHA.NR_CEP@">CEP</a>',
                parametro: "@TB_CMCRM_CONTATO.TESTEMUNHA.NR_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura da Testemunha" value="@ASSINATURA.TB_CMCRM_CONTATO.TESTEMUNHA.ID_CONTATO@">ASSINATURA_TESTEMUNHA</a>',
                parametro:
                    "@ASSINATURA.TB_CMCRM_CONTATO.TESTEMUNHA.ID_CONTATO@",
                campo: "ASSINATURA_TESTEMUNHA",
            },
        ],
    },
    {
        titleHtml: "Dados da Referência Pessoal",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados da Referência Pessoal" value="@UTIL.RF_PES.INICIO@">INICIO_RF_PES</a>',
                parametro: "@UTIL.RF_PES.INICIO@",
                campo: "INICIO_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados da Referência Pessoal" value="@UTIL.RF_PES.FIM@">FIM_RF_PES</a>',
                parametro: "@UTIL.RF_PES.FIM@",
                campo: "FIM_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_NOME@">NOME_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_NOME@",
                campo: "NOME_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DT_NASCIMENTO@">DT_NASCIMENTO_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DT_NASCIMENTO@",
                campo: "DT_NASCIMENTO_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Pai da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_NOME_PAI@">NOME_PAI_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_NOME_PAI@",
                campo: "NOME_PAI_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Mãe da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_NOME_MAE@">NOME_MAE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_NOME_MAE@",
                campo: "NOME_MAE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_RG_TIPO@">TIPO_REG_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.TIPO_REG_RF_PES@",
                campo: "TIPO_REG_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Registro da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.NR_RG@">RG_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.NR_RG@",
                campo: "RG_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do Registro da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_RG_ORGAO_EMISSOR@">RG_RF_PES_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_RG_ORGAO_EMISSOR@",
                campo: "RG_RF_PES_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do Registro da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_RG_UF_EMISSOR@">RG_RF_PES_UF</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_RG_UF_EMISSOR@",
                campo: "RG_RF_PES_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do Registro da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DT_RG_EMISSAO@">RG_RF_PES_DATA</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DT_RG_EMISSAO@",
                campo: "RG_RF_PES_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DT_RG_VALIDADE@">REG_RF_PES_VALIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DT_RG_VALIDADE@",
                campo: "REG_RF_PES_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_RG_CATEGORIA@">REG_RF_PES_CATEGORIA</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_RG_CATEGORIA@",
                campo: "REG_RF_PES_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.NR_CPF@">CPF/CNPJ_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.NR_CPF@",
                campo: "CPF/CNPJ_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_EMAIL@">EMAIL_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_EMAIL@",
                campo: "EMAIL_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.NR_TELEFONE@">TELEFONE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.NR_TELEFONE@",
                campo: "TELEFONE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_NACIONALIDADE@">NACIONAL_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_NACIONALIDADE@",
                campo: "NACIONAL_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_NATURALIDADE@">NATURALIDADE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_NATURALIDADE@",
                campo: "NATURALIDADE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_PROFISSAO@">PROFISSAO_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_PROFISSAO@",
                campo: "PROFISSAO_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado Civil da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_ESTADO_CIVIL@">ESTADO_CIVIL_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Regime de Comunhão da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_REGIME_COMUNHAO@">REGIME_COMUNHAO_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_REGIME_COMUNHAO@",
                campo: "REGIME_COMUNHAO_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_NOME_CONJUGE@">NOME_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_NOME_CONJUGE@",
                campo: "NOME_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_EMAIL_CONJUGE@">EMAIL_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_EMAIL_CONJUGE@",
                campo: "EMAIL_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.NR_TELEFONE_CONJUGE@">TELEFONE_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.NR_TELEFONE_CONJUGE@",
                campo: "TELEFONE_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.NR_CPF_CONJUGE@">CPF_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.NR_CPF_CONJUGE@",
                campo: "CPF_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.NR_RG_CONJUGE@">RG_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.NR_RG_CONJUGE@",
                campo: "RG_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_RG_ORGAO_EMISSOR_CONJUGE@">RG_EMISSOR_CONJUGE_RF_PES</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.RF_PES.DS_RG_ORGAO_EMISSOR_CONJUGE@",
                campo: "RG_EMISSOR_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_RG_UF_EMISSOR_CONJUGE@">RG_UF_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_RG_UF_EMISSOR_CONJUGE@",
                campo: "RG_UF_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DT_RG_EMISSAO_CONJUGE@">RG_DATA_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DT_RG_EMISSAO_CONJUGE@",
                campo: "RG_DATA_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo do RG do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_RG_TIPO_CONJUGE@">RG_TIPO_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_RG_TIPO_CONJUGE@",
                campo: "RG_TIPO_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do RG do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_RG_CATEGORIA_CONJUGE@">RG_CATEGORIA_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_RG_CATEGORIA_CONJUGE@",
                campo: "RG_CATEGORIA_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Validade do RG do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DT_RG_VALIDADE_CONJUGE@">RG_VALIDADE_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DT_RG_VALIDADE_CONJUGE@",
                campo: "RG_VALIDADE_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DT_NASCIMENTO_CONJUGE@">NASCIMENTO_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DT_NASCIMENTO_CONJUGE@",
                campo: "NASCIMENTO_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_NACIONALIDADE_CONJUGE@">NACIONALIDADE_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_NACIONALIDADE_CONJUGE@",
                campo: "NACIONALIDADE_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_NATURALIDADE_CONJUGE@">NATURALIDADE_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_NATURALIDADE_CONJUGE@",
                campo: "NATURALIDADE_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Cônjuge da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_PROFISSAO_CONJUGE@">PROFISSAO_CONJUGE_RF_PES</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_PROFISSAO_CONJUGE@",
                campo: "PROFISSAO_CONJUGE_RF_PES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.NR_ENDERECO@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.NR_ENDERECO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_BAIRRO@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_BAIRRO@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP da Referência Pessoal" value="@TB_CMCRM_CONTATO.RF_PES.NR_CEP@">CEP</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_PES.NR_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura da Referência Pessoal" value="@ASSINATURA.TB_CMCRM_CONTATO.RF_PES.ID_CONTATO@">ASSINATURA_RF_PES</a>',
                parametro: "@ASSINATURA.TB_CMCRM_CONTATO.RF_PES.ID_CONTATO@",
                campo: "ASSINATURA_RF_PES",
            },
        ],
    },
    {
        titleHtml: "Dados da Referência Financeira",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados da Referência Financeira" value="@UTIL.RF_FIN.INICIO@">INICIO_RF_FIN</a>',
                parametro: "@UTIL.RF_FIN.INICIO@",
                campo: "INICIO_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados da Referência Financeira" value="@UTIL.RF_FIN.FIM@">FIM_RF_FIN</a>',
                parametro: "@UTIL.RF_FIN.FIM@",
                campo: "FIM_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_NOME@">NOME_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_NOME@",
                campo: "NOME_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DT_NASCIMENTO@">DT_NASCIMENTO_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DT_NASCIMENTO@",
                campo: "DT_NASCIMENTO_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Pai da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_NOME_PAI@">NOME_PAI_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_NOME_PAI@",
                campo: "NOME_PAI_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Mãe da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_NOME_MAE@">NOME_MAE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_NOME_MAE@",
                campo: "NOME_MAE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Registro da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_RG_TIPO@">TIPO_REG_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.TIPO_REG_RF_FIN@",
                campo: "TIPO_REG_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Registro da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.NR_RG@">RG_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.NR_RG@",
                campo: "RG_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do Registro da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_RG_ORGAO_EMISSOR@">RG_RF_FIN_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_RG_ORGAO_EMISSOR@",
                campo: "RG_RF_FIN_EMISSOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do Registro da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_RG_UF_EMISSOR@">RG_RF_FIN_UF</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_RG_UF_EMISSOR@",
                campo: "RG_RF_FIN_UF",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do Registro da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DT_RG_EMISSAO@">RG_RF_FIN_DATA</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DT_RG_EMISSAO@",
                campo: "RG_RF_FIN_DATA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade do Registro da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DT_RG_VALIDADE@">REG_RF_FIN_VALIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DT_RG_VALIDADE@",
                campo: "REG_RF_FIN_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do Registro da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_RG_CATEGORIA@">REG_RF_FIN_CATEGORIA</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_RG_CATEGORIA@",
                campo: "REG_RF_FIN_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.NR_CPF@">CPF/CNPJ_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.NR_CPF@",
                campo: "CPF/CNPJ_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_EMAIL@">EMAIL_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_EMAIL@",
                campo: "EMAIL_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.NR_TELEFONE@">TELEFONE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.NR_TELEFONE@",
                campo: "TELEFONE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_NACIONALIDADE@">NACIONAL_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_NACIONALIDADE@",
                campo: "NACIONAL_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_NATURALIDADE@">NATURALIDADE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_NATURALIDADE@",
                campo: "NATURALIDADE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_PROFISSAO@">PROFISSAO_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_PROFISSAO@",
                campo: "PROFISSAO_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado Civil da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_ESTADO_CIVIL@">ESTADO_CIVIL_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Regime de Comunhão da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_REGIME_COMUNHAO@">REGIME_COMUNHAO_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_REGIME_COMUNHAO@",
                campo: "REGIME_COMUNHAO_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_NOME_CONJUGE@">NOME_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_NOME_CONJUGE@",
                campo: "NOME_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_EMAIL_CONJUGE@">EMAIL_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_EMAIL_CONJUGE@",
                campo: "EMAIL_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.NR_TELEFONE_CONJUGE@">TELEFONE_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.NR_TELEFONE_CONJUGE@",
                campo: "TELEFONE_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.NR_CPF_CONJUGE@">CPF_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.NR_CPF_CONJUGE@",
                campo: "CPF_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.NR_RG_CONJUGE@">RG_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.NR_RG_CONJUGE@",
                campo: "RG_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Órgão Emissor do RG do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_RG_ORGAO_EMISSOR_CONJUGE@">RG_EMISSOR_CONJUGE_RF_FIN</a>',
                parametro:
                    "@TB_CMCRM_CONTATO.RF_FIN.DS_RG_ORGAO_EMISSOR_CONJUGE@",
                campo: "RG_EMISSOR_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="UF do RG do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_RG_UF_EMISSOR_CONJUGE@">RG_UF_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_RG_UF_EMISSOR_CONJUGE@",
                campo: "RG_UF_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Emissão do RG do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DT_RG_EMISSAO_CONJUGE@">RG_DATA_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DT_RG_EMISSAO_CONJUGE@",
                campo: "RG_DATA_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo do RG do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_RG_TIPO_CONJUGE@">RG_TIPO_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_RG_TIPO_CONJUGE@",
                campo: "RG_TIPO_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria do RG do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_RG_CATEGORIA_CONJUGE@">RG_CATEGORIA_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_RG_CATEGORIA_CONJUGE@",
                campo: "RG_CATEGORIA_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Validade do RG do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DT_RG_VALIDADE_CONJUGE@">RG_VALIDADE_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DT_RG_VALIDADE_CONJUGE@",
                campo: "RG_VALIDADE_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Nascimento do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DT_NASCIMENTO_CONJUGE@">NASCIMENTO_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DT_NASCIMENTO_CONJUGE@",
                campo: "NASCIMENTO_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nacionalidade do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_NACIONALIDADE_CONJUGE@">NACIONALIDADE_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_NACIONALIDADE_CONJUGE@",
                campo: "NACIONALIDADE_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Naturalidade do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_NATURALIDADE_CONJUGE@">NATURALIDADE_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_NATURALIDADE_CONJUGE@",
                campo: "NATURALIDADE_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Profissão do Cônjuge da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_PROFISSAO_CONJUGE@">PROFISSAO_CONJUGE_RF_FIN</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_PROFISSAO_CONJUGE@",
                campo: "PROFISSAO_CONJUGE_RF_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.NR_ENDERECO@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.NR_ENDERECO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_BAIRRO@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_BAIRRO@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP da Referência Financeira" value="@TB_CMCRM_CONTATO.RF_FIN.NR_CEP@">CEP</a>',
                parametro: "@TB_CMCRM_CONTATO.RF_FIN.NR_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura da Referência Financeira" value="@ASSINATURA.TB_CMCRM_CONTATO.RF_FIN.ID_CONTATO@">ASSINATURA_RF_FIN</a>',
                parametro: "@ASSINATURA.TB_CMCRM_CONTATO.RF_FIN.ID_CONTATO@",
                campo: "ASSINATURA_RF_FIN",
            },
        ],
    },
    {
        titleHtml: "Dados da Imobiliária",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_NOME_EQUIPE@">NOME</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_NOME_EQUIPE@",
                campo: "NOME",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome Fantasia da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_NOME_FANTASIA@">NOME_FANTASIA</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_NOME_FANTASIA@",
                campo: "NOME_FANTASIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CNPJ da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.NR_CNPJ@">CNPJ</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.NR_CNPJ@",
                campo: "CNPJ",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.NR_NUMERO@">NUMERO</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.NR_NUMERO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_COMPLEMENTO@">COMPLEMENTO</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_COMPLEMENTO@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_BAIRRO@">BAIRRO</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_BAIRRO@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP da Imobiliária" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_CEP@">CEP</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CRECI Equipe de Vendas" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_CRECI@">CRECI_EQUIPE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_CRECI@",
                campo: "CRECI_EQUIPE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="EMAIL Equipe de Vendas" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_EMAIL@">EMAIL_EQUIPE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.DS_EMAIL@",
                campo: "EMAIL_EQUIPE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="EMAIL Equipe de Vendas" value="@TB_CMC_USUARIO.EQUIPE_VENDAS.NR_TELEFONE@">TELEFONE_EQUIPE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.EQUIPE_VENDAS.NR_TELEFONE@",
                campo: "TELEFONE_EQUIPE_VENDAS",
            },
        ],
    },
    {
        titleHtml: "Dados do Imóvel",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Empreendimento" value="@TB_CMCRM_PRODUTO.PAI.DS_PRODUTO@">EMPREENDIMENTO</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_PRODUTO@",
                campo: "EMPREENDIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nº do Alvará" value="@TB_CMCRM_PRODUTO.PAI.NR_ALVARA@">NR_ALVARA</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.NR_ALVARA@",
                campo: "NR_ALVARA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Identificador da Unidade" value="@TB_CMCRM_PRODUTO.ID_PRODUTO@">NUM_CADASTRO</a>',
                parametro: "@TB_CMCRM_PRODUTO.ID_PRODUTO@",
                campo: "NUM_CADASTRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Produto" value="@TB_CMCRM_PRODUTO.NR_PRODUTO@">NR_PRODUTO</a>',
                parametro: "@TB_CMCRM_PRODUTO.NR_PRODUTO@",
                campo: "NR_PRODUTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome da Unidade" value="@TB_CMCRM_PRODUTO.DS_UNIDADE@">UNIDADE/LOTE</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_UNIDADE@",
                campo: "UNIDADE/LOTE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Empreendimento" value="@TB_CMCRM_PRODUTO.DS_LOGRADOURO@">ENDERECO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_LOGRADOURO@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Endereço da Unidade" value="@TB_CMCRM_PRODUTO.NR_NUMERO@">NUMERO</a>',
                parametro: "@TB_CMCRM_PRODUTO.NR_NUMERO@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade da Unidade" value="@TB_CMCRM_PRODUTO.DS_CIDADE@">CIDADE</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CIDADE@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado da Unidade" value="@TB_CMCRM_PRODUTO.DS_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP da Unidade" value="@TB_CMCRM_PRODUTO.DS_CEP@">CEP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CEP@",
                campo: "CEP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Logradouro da Unidade" value="@TB_CMCRM_PRODUTO.DS_LOGRADOURO_PRODUTO@">LOGRADOURO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_LOGRADOURO_PRODUTO@",
                campo: "LOGRADOURO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo da Unidade" value="@TB_CMCRM_PRODUTO.DS_TIPO_PRODUTO@">TIPO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_TIPO_PRODUTO@",
                campo: "TIPO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quadra da Unidade" value="@TB_CMCRM_PRODUTO.NR_QUADRA@">QUADRA</a>',
                parametro: "@TB_CMCRM_PRODUTO.NR_QUADRA@",
                campo: "QUADRA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bloco da Unidade" value="@TB_CMCRM_PRODUTO.DS_BLOCO@">BLOCO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_BLOCO@",
                campo: "BLOCO",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Torre da Unidade" value="@TB_CMCRM_PRODUTO.DS_TORRE@">TORRE</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_TORRE@",
                campo: "DS_TORRE",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Vagas da Unidade" value="@TB_CMCRM_PRODUTO.NR_VAGAS@">QTD_VAGAS</a>',
                parametro: "@TB_CMCRM_PRODUTO.NR_VAGAS@",
                campo: "QTD_VAGAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Descrição das Vagas da Unidade" value="@TB_CMCRM_PRODUTO.DS_VAGAS@">NUM_VAGA</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_VAGAS@",
                campo: "NUM_VAGA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Quartos da Unidade" value="@TB_CMCRM_PRODUTO.NR_QUARTOS@">QTD_QUARTOS</a>',
                parametro: "@TB_CMCRM_PRODUTO.NR_QUARTOS@",
                campo: "QTD_QUARTOS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Andar da Unidade" value="@TB_CMCRM_PRODUTO.NR_ANDAR@">ANDAR</a>',
                parametro: "@TB_CMCRM_PRODUTO.NR_ANDAR@",
                campo: "ANDAR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Área Total (em m²) da Unidade" value="@TB_CMCRM_PRODUTO.VL_METROS_QUADRADOS@">AREA_TOTAL</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_METROS_QUADRADOS@",
                campo: "AREA_TOTAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Área Privativa (em m²) da Unidade" value="@TB_CMCRM_PRODUTO.VL_AREA_PRIVATIVA@">AREA_PRIVATIVA</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_AREA_PRIVATIVA@",
                campo: "AREA_PRIVATIVA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Área Comum (em m²) da Unidade" value="@TB_CMCRM_PRODUTO.VL_AREA_COMUM@">AREA_COMUM</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_AREA_COMUM@",
                campo: "AREA_COMUM",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Medida da Frente (em m²) da Unidade" value="@TB_CMCRM_PRODUTO.VL_MEDIDA_FRENTE@">VL_FRENTE</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_MEDIDA_FRENTE@",
                campo: "VL_FRENTE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Medida dos Fundos (em m²) da Unidade" value="@TB_CMCRM_PRODUTO.VL_MEDIDA_FUNDOS@">VL_FUNDOS</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_MEDIDA_FUNDOS@",
                campo: "VL_FUNDOS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Medida da Direita (em m²) da Unidade" value="@TB_CMCRM_PRODUTO.VL_MEDIDA_DIREITA@">VL_DIREITA</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_MEDIDA_DIREITA@",
                campo: "VL_DIREITA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Medida da Esquerda (em m²) da Unidade" value="@TB_CMCRM_PRODUTO.VL_MEDIDA_ESQUERDA@">VL_ESQUERDA</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_MEDIDA_ESQUERDA@",
                campo: "VL_ESQUERDA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Confrontante da Frente da Unidade" value="@TB_CMCRM_PRODUTO.DS_CONFRONTANTE_FRENTE@">CF_FRENTE</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CONFRONTANTE_FRENTE@",
                campo: "CF_FRENTE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Confrontante dos Fundos da Unidade" value="@TB_CMCRM_PRODUTO.DS_CONFRONTANTE_FUNDOS@">CF_FUNDOS</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CONFRONTANTE_FUNDOS@",
                campo: "CF_FUNDOS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Confrontante da Direita da Unidade" value="@TB_CMCRM_PRODUTO.DS_CONFRONTANTE_DIREITA@">CF_DIREITA</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CONFRONTANTE_DIREITA@",
                campo: "CF_DIREITA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Confrontante da Esquerda da Unidade" value="@TB_CMCRM_PRODUTO.DS_CONFRONTANTE_ESQUERDA@">CF_ESQUERDA</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CONFRONTANTE_ESQUERDA@",
                campo: "CF_ESQUERDA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Fração Ideal da Unidade" value="@TB_CMCRM_PRODUTO.VL_FRACAO_IDEAL@">FRACAO_IDEAL</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_FRACAO_IDEAL@",
                campo: "FRACAO_IDEAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Ficha Técnica da Unidade" value="@TB_CMCRM_PRODUTO.DS_FICHA_TECNICA@">FICHA_UNIDADE</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_FICHA_TECNICA@",
                campo: "FICHA_UNIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Ficha Técnica do Empreendimento" value="@TB_CMCRM_PRODUTO.PAI.DS_FICHA_TECNICA@">FICHA_EMPREENDIMENTO</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_FICHA_TECNICA@",
                campo: "FICHA_EMPREENDIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Percentual da Unidade Pertencente a Empresa" value="@TB_CMCRM_PRODUTO.VL_PERCENTUAL_EMPRESA@">%_EMPRESA</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_PERCENTUAL_EMPRESA@",
                campo: "%_EMPRESA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Percentual da Unidade Pertencente ao Terreneiro" value="@TB_CMCRM_PRODUTO.VL_PERCENTUAL_TERRENEIRO@">%_TERRENEIRO</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_PERCENTUAL_TERRENEIRO@",
                campo: "%_TERRENEIRO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Registro de Incorporação do Empreendimento" value="@TB_CMCRM_PRODUTO.PAI.DS_REGISTRO_INCORPORACAO@">REGISTRO_INCORP</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_REGISTRO_INCORPORACAO@",
                campo: "REGISTRO_INCORP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Previsão de Conclusão do Empreendimento" value="@TB_CMCRM_PRODUTO.PAI.DT_PREVISAO_CONCLUSAO@">DATA_PREVISAO</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DT_PREVISAO_CONCLUSAO@",
                campo: "DATA_PREVISAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data do Habite-se" value="@TB_CMCRM_PRODUTO.PAI.DT_HABITESE@">DATA_HABITESE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DT_HABITESE@",
                campo: "DATA_HABITESE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Informação do Habite-se" value="@TB_CMCRM_PRODUTO.PAI.DS_INFO_HABITESE@">INFO_HABITESE</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_INFO_HABITESE@",
                campo: "INFO_HABITESE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Campo Empresa do ERP" value="@TB_CMCRM_PRODUTO.CHAVE_ERP_EMPRESA@">CHAVE_ERP_EMPRESA</a>',
                parametro: "@TB_CMCRM_PRODUTO.CHAVE_ERP_EMPRESA@",
                campo: "CHAVE_ERP_EMPRESA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Campo Obra do ERP" value="@TB_CMCRM_PRODUTO.CHAVE_ERP_OBRA@">CHAVE_ERP_OBRA</a>',
                parametro: "@TB_CMCRM_PRODUTO.CHAVE_ERP_OBRA@",
                campo: "CHAVE_ERP_OBRA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Campo Venda do ERP" value="@TB_CMCRM_PRODUTO.CHAVE_ERP_VENDA@">CHAVE_ERP_VENDA</a>',
                parametro: "@TB_CMCRM_PRODUTO.CHAVE_ERP_VENDA@",
                campo: "CHAVE_ERP_VENDA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número de Matrícula da Unidade" value="@TB_CMCRM_PRODUTO.NR_MATRICULA@">NUM_MATRICULA</a>',
                parametro: "@TB_CMCRM_PRODUTO.NR_MATRICULA@",
                campo: "NUM_MATRICULA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bonificação do Empreendimento" value="@TB_CMCRM_PRODUTO.PAI.DS_BONIFICACAO@">BONIFICACAO</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DS_BONIFICACAO@",
                campo: "BONIFICACAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Início da Bonificação do Empreendimento" value="@TB_CMCRM_PRODUTO.PAI.DT_INICIO_BONIFICACAO@">DT_INICIO_BONIFICACAO</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DT_INICIO_BONIFICACAO@",
                campo: "DT_INICIO_BONIFICACAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Fim da Bonificação do Empreendimento" value="@TB_CMCRM_PRODUTO.PAI.DT_FIM_BONIFICACAO@">DT_FIM_BONIFICACAO</a>',
                parametro: "@TB_CMCRM_PRODUTO.PAI.DT_FIM_BONIFICACAO@",
                campo: "DT_FIM_BONIFICACAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Acessão" value="@TB_CMCRM_PRODUTO.VL_ACESSAO@">VL_ACESSAO</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_ACESSAO@",
                campo: "VL_ACESSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Valor Acessão" value="@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_ACESSAO@">VL_PROPOSTA_SEM_ACESSAO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_ACESSAO@",
                campo: "VL_PROPOSTA_SEM_ACESSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Escaninho" value="@TB_CMCRM_PRODUTO.DS_ESCANINHO@">DS_ESCANINHO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_ESCANINHO@",
                campo: "DS_ESCANINHO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Preço Escaninho" value="@TB_CMCRM_PRODUTO.VL_ESCANINHO@">VL_ESCANINHO</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_ESCANINHO@",
                campo: "VL_ESCANINHO",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Avaliação Caixa" value="@TB_CMCRM_PRODUTO.VL_AVALIACAO_CAIXA@">VL_AVALIACAO_CAIXA</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_AVALIACAO_CAIXA@",
                campo: "VL_AVALIACAO_CAIXA",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor / m²" value="@TB_CMCRM_PRODUTO.VL_PRECO_METROS_QUADRADOS@">VL_PRECO_METROS_QUADRADOS</a>',
                parametro: "@TB_CMCRM_PRODUTO.VL_PRECO_METROS_QUADRADOS@",
                campo: "VL_PRECO_METROS_QUADRADOS",
            },
        ],
    },
    {
        titleHtml: "Dados da Análise de Crédito",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor do Calção" value="@TB_CMCRM_ANALISE_CREDITO.VL_CALCAO@">VL_CAUCAO</a>',
                parametro: "@TB_CMCRM_ANALISE_CREDITO.VL_CALCAO@",
                campo: "VL_CAUCAO",
            },
        ],
    },
    {
        titleHtml: "Dados da Cláusula em Tempo",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados da Cláusula em Tempo" value="@UTIL.CLAUSULA.INICIO@">INICIO_CLAUSULA</a>',
                parametro: "@UTIL.CLAUSULA.INICIO@",
                campo: "INICIO_CLAUSULA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados da Cláusula em Tempo" value="@UTIL.CLAUSULA.FIM@">FIM_CLAUSULA</a>',
                parametro: "@UTIL.CLAUSULA.FIM@",
                campo: "FIM_CLAUSULA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cláusula" value="@TB_CMCRM_CASO_CLAUSULA.DS_CASO_CLAUSULA@">DS_CLAUSULA</a>',
                parametro: "@TB_CMCRM_CASO_CLAUSULA.DS_CASO_CLAUSULA@",
                campo: "DS_CLAUSULA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data da Cláusula" value="@TB_CMCRM_CASO_CLAUSULA.DT_CASO_CLAUSULA@">DT_CLAUSULA</a>',
                parametro: "@TB_CMCRM_CASO_CLAUSULA.DT_CASO_CLAUSULA@",
                campo: "DT_CLAUSULA_TEMPO",
            },
        ],
    },
    {
        titleHtml: "Dados da Reserva",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Unidade Reservada" value="@TB_CMCRM_PRODUTO.DS_PRODUTO_RESERVA@">UNIDADE_RESERVADA</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO_RESERVA@",
                campo: "UNIDADE_RESERVADA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Preco" value="@TB_CMCRM_UNIDADE.VL_PRECO@">VL_PRECO</a>',
                parametro: "@TB_CMCRM_UNIDADE.VL_PRECO@",
                campo: "VL_PRECO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Preco por Extenso" value="@TB_CMCRM_UNIDADE.EXTENSO.VL_PRECO@">VL_PRECO_EXTENSO</a>',
                parametro: "@TB_CMCRM_UNIDADE.EXTENSO.VL_PRECO@",
                campo: "VL_PRECO",
            },
        ],
    },
    {
        titleHtml: "Dados da Proposta",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número do Caso" value="@TB_CMCRM_PROPOSTA.ID_CASO@">NUM_CASO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.ID_CASO@",
                campo: "NUM_CASO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número da Proposta" value="@TB_CMCRM_PROPOSTA.ID_PROPOSTA@">NUM_PROPOSTA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.ID_PROPOSTA@",
                campo: "NUM_PROPOSTA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Descrição da Proposta" value="@TB_CMCRM_PROPOSTA.DS_DESCRICAO@">DESCRICAO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DS_DESCRICAO@",
                campo: "DESCRICAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Status da Proposta" value="@TB_CMCRM_PROPOSTA.DS_STATUS@">STATUS</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DS_STATUS@",
                campo: "STATUS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Usuário de Aprovação" value="@TB_CMCRM_PROPOSTA.DS_NOME_USUARIO_APROVACAO@">APROVADOR</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DS_NOME_USUARIO_APROVACAO@",
                campo: "APROVADOR",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Proposta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL@">VL_PROPOSTA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL@",
                campo: "VL_PROPOSTA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL@">VL_PROPOSTA_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL@",
                campo: "VL_PROPOSTA_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total Capitalizado da Proposta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_CAPITALIZADO@">VL_PROPOSTA_CAP</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_CAPITALIZADO@",
                campo: "VL_PROPOSTA_CAP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total Capitalizado por Extenso da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_CAPITALIZADO@">VL_PROPOSTA_CAP_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_CAPITALIZADO@",
                campo: "VL_PROPOSTA_CAP_EXTENSO",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Até Chaves: Valor da Proposta até o Financiamento" value="@TB_CMCRM_PROPOSTA.VL_ATE_CHAVES@">VL_ATE_CHAVES</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_ATE_CHAVES@",
                campo: "VL_ATE_CHAVES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Tabela - Valor da Proposta" value="@TB_CMCRM_PROPOSTA.VL_DIFERENCA_TABELA@">VL_DIFERENCA_TABELA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_DIFERENCA_TABELA@",
                campo: "VL_DIFERENCA_TABELA",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Comissão Direta da Proposta" value="@TB_CMCRM_PROPOSTA.VL_COMISSAO_DIRETA@">VL_COMISSAO_DIR</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_COMISSAO_DIRETA@",
                campo: "VL_COMISSAO_DIR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor por Extenso da Comissão Direta da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_COMISSAO_DIRETA@">VALOR_COMISSAO_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_COMISSAO_DIRETA@",
                campo: "VL_COMISSAO_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Comissão Faturada da Proposta" value="@TB_CMCRM_PROPOSTA.VL_COMISSAO_FATURADA@">VL_COMISSAO_FAT</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_COMISSAO_FATURADA@",
                campo: "VL_COMISSAO_FAT",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor por Extenso da Comissão Faturada da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_COMISSAO_FATURADA@">VL_COMISSAO_FAT_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_COMISSAO_FATURADA@",
                campo: "VL_COMISSAO_FAT_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Percentual da Comissão Faturada da Proposta" value="@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_COMISSAO@">%_COMISSAO_FAT</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_COMISSAO@",
                campo: "%_COMISSAO_FAT",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Percentual da Comissão Direta da Proposta" value="@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_COMISSAO_DIR@">%_COMISSAO_DIR</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_COMISSAO_DIR@",
                campo: "%_COMISSAO_DIR",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Comissão Direta da Proposta (Exibidos em Contrato)" value="@TB_CMCRM_PROPOSTA.VL_COMISSAO_DIRETA_CONT@">VL_COMISSAO_DIR_CONT</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_COMISSAO_DIRETA_CONT@",
                campo: "VL_COMISSAO_DIR_CONT",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor por Extenso da Comissão Direta da Proposta (Exibidos em Contrato)" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_COMISSAO_DIRETA_CONT@">VALOR_COMISSAO_EXTENSO_CONT</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.EXTENSO.VL_COMISSAO_DIRETA_CONT@",
                campo: "VL_COMISSAO_EXTENSO_CONT",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Comissão Faturada da Proposta (Exibidos em Contrato)" value="@TB_CMCRM_PROPOSTA.VL_COMISSAO_FATURADA_CONT@">VL_COMISSAO_FAT_CONT</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_COMISSAO_FATURADA_CONT@",
                campo: "VL_COMISSAO_FAT_CONT",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor por Extenso da Comissão Faturada da Proposta (Exibidos em Contrato)" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_COMISSAO_FATURADA_CONT@">VL_COMISSAO_FAT_EXTENSO_CONT</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.EXTENSO.VL_COMISSAO_FATURADA_CONT@",
                campo: "VL_COMISSAO_FAT_EXTENSO_CONT",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Percentual da Comissão Faturada da Proposta (Exibidos em Contrato)" value="@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_COMISSAO_CONT@">%_COMISSAO_FAT_CONT</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_COMISSAO_CONT@",
                campo: "%_COMISSAO_FAT_CONT",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Estrutura de Comissão" value="@TB_CMCRM_PROPOSTA.VL_EST_COMISSAO@">VL_EST_COMISSAO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_EST_COMISSAO@",
                campo: "VL_EST_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Estrutura de Comissão por Extenso" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_EST_COMISSAO@">VL_EST_COMISSAO_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_EST_COMISSAO@",
                campo: "VL_EST_COMISSAO_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total dos Comissionados em contrato" value="@TB_CMCRM_PROPOSTA.VL_EST_COMISSAO_CONT@">VL_EST_COMISSAO_CONT</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_EST_COMISSAO_CONT@",
                campo: "VL_EST_COMISSAO_CONT",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta (Parcelas Comissionadas) + Comissão Faturada" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_COMISSAO@">VL_PROPOSTA_E_COMISSAO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_COMISSAO@",
                campo: "VL_PROPOSTA_E_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta + Comissão Faturada" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_PROPOSTA@">VL_TOTAL_PROPOSTA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_PROPOSTA@",
                campo: "VL_TOTAL_PROPOSTA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta + Comissão Faturada por Extenso" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_COMISSAO@">VL_PROPOSTA_COMISSAO_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_COMISSAO@",
                campo: "VL_PROPOSTA_COMISSAO_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta + Comissão Direta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_COMISSAO_DIRETA@">VL_PROPOSTA_E_COMISSAO_DIR</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_COMISSAO_DIRETA@",
                campo: "VL_PROPOSTA_E_COMISSAO_DIR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta + Comissão Direta por Extenso" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_COMISSAO_DIRETA@">VL_PROPOSTA_COMISSAO_DIR_EXTENSO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_COMISSAO_DIRETA@",
                campo: "VL_PROPOSTA_COMISSAO_DIR_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Desconto da Proposta + Comissão" value="@TB_CMCRM_PROPOSTA.VL_DESCONTO@">VL_DESCONTO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_DESCONTO@",
                campo: "VL_DESCONTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual de Desconto da Proposta + Comissão" value="@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_DESCONTO@">%_DESCONTO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_DESCONTO@",
                campo: "%_DESCONTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Bônus Adimplência da Proposta" value="@TB_CMCRM_PROPOSTA.VL_BONUS_INADIMPLENCIA@">VL_BONUS_ADIMPLENCIA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_BONUS_INADIMPLENCIA@",
                campo: "VL_BONUS_ADIMPLENCIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Criação da Proposta" value="@TB_CMCRM_PROPOSTA.DT_CRIACAO@">DATA_PROPOSTA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DT_CRIACAO@",
                campo: "DATA_PROPOSTA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Validade da Proposta" value="@TB_CMCRM_PROPOSTA.DT_VALIDADE@">DATA_VALIDADE</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DT_VALIDADE@",
                campo: "DATA_VALIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Entrada + Sinal" value="@TB_CMCRM_PROPOSTA.VL_ENTRADA_COM_SINAL@">VL_ENTRADA_COM_SINAL</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_ENTRADA_COM_SINAL@",
                campo: "VL_ENTRADA_COM_SINAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Sinal" value="@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_SINAL@">VL_PROPOSTA_SEM_SINAL</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_SINAL@",
                campo: "VL_PROPOSTA_SEM_SINAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Sinal por Extenso" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_SEM_SINAL@">VL_PROPOSTA_SEM_SINAL_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_SEM_SINAL@",
                campo: "VL_PROPOSTA_SEM_SINAL_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Pró Soluto" value="@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_PRO_SOLUTO@">VL_PROPOSTA_SEM_PRO_SOLUTO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_PRO_SOLUTO@",
                campo: "VL_PROPOSTA_SEM_PRO_SOLUTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Pró Soluto por Extenso" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_SEM_PRO_SOLUTO@">VL_PROPOSTA_SEM_PRO_SOLUTO_EXTENSO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_SEM_PRO_SOLUTO@",
                campo: "VL_PROPOSTA_SEM_PRO_SOLUTO_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Financiamento - Subsídio" value="@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_FIN_SUB@">VL_PROPOSTA_SEM_FIN_SUB</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_FIN_SUB@",
                campo: "VL_PROPOSTA_SEM_FIN_SUB",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Financiamento - Subsídio por Extenso" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_SEM_FIN_SUB@">VL_PROPOSTA_SEM_FIN_SUB_EXTENSO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_SEM_FIN_SUB@",
                campo: "VL_PROPOSTA_SEM_FIN_SUB_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Sinal - Entrada" value="@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_SIN_ENT@">VL_PROPOSTA_SEM_SIN_ENT</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PROPOSTA_SEM_SIN_ENT@",
                campo: "VL_PROPOSTA_SEM_SIN_ENT",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta - Sinal - Entrada por Extenso" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_SEM_SIN_ENT@">VL_PROPOSTA_SEM_SIN_ENT_EXTENSO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_SEM_SIN_ENT@",
                campo: "VL_PROPOSTA_SEM_SIN_ENT_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta Capitalizado - Comissão Direta - Descontos" value="@TB_CMCRM_PROPOSTA.VL_PROPOSTA_CAP_SEM_DIR_DES@">VL_PROPOSTA_CAP_SEM_DIR_DES</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PROPOSTA_CAP_SEM_DIR_DES@",
                campo: "VL_PROPOSTA_CAP_SEM_DIR_DES",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Proposta Capitalizado - Comissão Direta - Descontos por Extenso" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_CAP_SEM_DIR_DES@">VL_PROPOSTA_CAP_SEM_DIR_DES_EXTENSO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.EXTENSO.VL_PROPOSTA_CAP_SEM_DIR_DES@",
                campo: "VL_PROPOSTA_CAP_SEM_DIR_DES_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Dia de Criação da Proposta" value="@TB_CMCRM_PROPOSTA.DT_CRIACAO.DIA@">PROPOSTA_DIA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DT_CRIACAO.DIA@",
                campo: "PROPOSTA_DIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela da Proposta" value="@TB_CMCRM_PROPOSTA.DT_VENCIMENTO_ULTIMA_PARCELA@">DT_VENCIMENTO_ULTIMA_PARCELA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DT_VENCIMENTO_ULTIMA_PARCELA@",
                campo: "DT_VENCIMENTO_ULTIMA_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Mês (Por Extenso) de Criação da Proposta" value="@TB_CMCRM_PROPOSTA.DT_CRIACAO.MES_EXTENSO@">PROPOSTA_MÊS_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DT_CRIACAO.MES_EXTENSO@",
                campo: "PROPOSTA_MÊS_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Mês (Numérico) de Criação da Proposta" value="@TB_CMCRM_PROPOSTA.DT_CRIACAO.MES_NUM@">PROPOSTA_MÊS_NUMÉRICO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DT_CRIACAO.MES_NUM@",
                campo: "PROPOSTA_MÊS_NUMÉRICO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Ano de Criação da Proposta" value="@TB_CMCRM_PROPOSTA.DT_CRIACAO.ANO@">PROPOSTA_ANO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.DT_CRIACAO.ANO@",
                campo: "PROPOSTA_ANO",
            },
        ],
    },
    {
        titleHtml: "Dados das Séries",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DS_TIPO_PARCELA@">TIPO_SERIE</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DS_TIPO_PARCELA@",
                campo: "TIPO_SERIE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro: "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela da Série - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PARCELA@">VALOR_SERIE</a>',
                parametro: "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PARCELA@",
                campo: "VALOR_SERIE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Série sem Capitalização" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PARCELA_SEM_CAP@">VALOR_SERIE_SEM_CAP</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PARCELA_SEM_CAP@",
                campo: "VALOR_SERIE_SEM_CAP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Série - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PARCELA_COMISSAO@">VALOR_SERIE_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PARCELA_COMISSAO@",
                campo: "VALOR_SERIE_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PERCENTUAL_SERIE@">%_SERIE</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PERCENTUAL_SERIE@",
                campo: "%_SERIE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total da Série - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PERCENTUAL_SERIE_COMISSAO@">%_SERIE_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_PERCENTUAL_SERIE_COMISSAO@",
                campo: "%_SERIE_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Desconto da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DESCONTO@">VALOR_DESCONTO</a>',
                parametro: "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DESCONTO@",
                campo: "VALOR_DESCONTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Periodicidade da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.NR_PERIODICIDADE@">PERIODICIDADE</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.NR_PERIODICIDADE@",
                campo: "PERIODICIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro: "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Índice da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DS_INDICE@">INDICE</a>',
                parametro: "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DS_INDICE@",
                campo: "INDICE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Amortização da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DS_TIPO_AMORTIZACAO@">AMORTIZAÇÃO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.DS_TIPO_AMORTIZACAO@",
                campo: "AMORTIZAÇÃO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro: "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início das Parcelas da Série" value="@UTIL.SERIE_PARCELAS.INICIO@">INICIO_PARCELAS</a>',
                parametro: "@UTIL.SERIE_PARCELAS.INICIO@",
                campo: "INICIO_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim das Parcelas da Série" value="@UTIL.SERIE_PARCELAS.FIM@">FIM_PARCELAS</a>',
                parametro: "@UTIL.SERIE_PARCELAS.FIM@",
                campo: "FIM_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Número da Parcela da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_PARCELAS.NR_PARCELA@">NUM_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_PARCELAS.NR_PARCELA@",
                campo: "NUM_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Parcela da Série" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_PARCELAS.DT_VENCIMENTO@">DT_VENCIMENTO_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_PARCELAS.DT_VENCIMENTO@",
                campo: "DT_VENCIMENTO_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual da Parcela" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_PARCELAS.VL_PERCENTUAL_PARCELA@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_PARCELAS.VL_PERCENTUAL_PARCELA@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual da Parcela" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_PARCELAS.VL_PERCENTUAL_PARCELA_COMISSAO@">%_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_PARCELAS.VL_PERCENTUAL_PARCELA_COMISSAO@",
                campo: "%_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados das Séries Comissionadas",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados das SÉRIES COMISSIONADAS" value="@UTIL.SERIE_COM.INICIO@">INICIO_SERIE_COM</a>',
                parametro: "@UTIL.SERIE_COM.INICIO@",
                campo: "INICIO_SERIE_COM",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados das SÉRIES COMISSIONADAS" value="@UTIL.SERIE_COM.FIM@">FIM_SERIE_COM</a>',
                parametro: "@UTIL.SERIE_COM.FIM@",
                campo: "FIM_SERIE_COM",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo da SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.DS_TIPO_PARCELA@">TIPO_SERIE</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.DS_TIPO_PARCELA@",
                campo: "TIPO_SERIE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas das SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.VL_PARCELA@">VALOR_SERIE</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.VL_PARCELA@",
                campo: "VALOR_SERIE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total das SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Periodicidade da Parcela SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.NR_PERIODICIDADE@">PERIODICIDADE</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.NR_PERIODICIDADE@",
                campo: "PERIODICIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela das SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela das SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento das SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros das SÉRIES COMISSIONADAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SERIE_COM.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
        ],
    },
    {
        titleHtml: "Dados da Comissão",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Comissionado" value="@TB_CMCRM_ESTRUTURA_COMISSAO.DS_NOME_COMISSIONADO@">NOME_COMISSIONADO</a>',
                parametro: "@TB_CMCRM_ESTRUTURA_COMISSAO.DS_NOME_COMISSIONADO@",
                campo: "NOME_COMISSIONADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CRECI do Comissionado" value="@TB_CMCRM_ESTRUTURA_COMISSAO.DS_CRECI@">CRECI_COMISSIONADO</a>',
                parametro: "@TB_CMCRM_ESTRUTURA_COMISSAO.DS_CRECI@",
                campo: "CRECI_COMISSIONADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Descrição da Comissão" value="@TB_CMCRM_ESTRUTURA_COMISSAO.DS_COMISSIONADO@">COMISSIONADO</a>',
                parametro: "@TB_CMCRM_ESTRUTURA_COMISSAO.DS_COMISSIONADO@",
                campo: "COMISSIONADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Percentual da Comissão" value="@TB_CMCRM_ESTRUTURA_COMISSAO.VL_PERCENTUAL@">VL_PERCENTUAL</a>',
                parametro: "@TB_CMCRM_ESTRUTURA_COMISSAO.VL_PERCENTUAL@",
                campo: "VL_PERCENTUAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Comissão" value="@TB_CMCRM_ESTRUTURA_COMISSAO.VL_COMISSAO@">VL_COMISSAO</a>',
                parametro: "@TB_CMCRM_ESTRUTURA_COMISSAO.VL_COMISSAO@",
                campo: "VL_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados de Pagamento da Comissão",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Parcela do Pagamento da Comissão" value="@TB_CMCRM_ESTRUTURA_COMISSAO.PAGAMENTO.DS_TIPO_PARCELA@">DS_PARCELA_PAGAMENTO_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_ESTRUTURA_COMISSAO.PAGAMENTO.DS_TIPO_PARCELA@",
                campo: "DS_PARCELA_PAGAMENTO_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data do Pagamento da Comissão" value="@TB_CMCRM_ESTRUTURA_COMISSAO.PAGAMENTO.DT_PAGAMENTO@">DT_PAGAMENTO_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_ESTRUTURA_COMISSAO.PAGAMENTO.DT_PAGAMENTO@",
                campo: "DT_PAGAMENTO_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor do Pagamento da Comissão" value="@TB_CMCRM_ESTRUTURA_COMISSAO.PAGAMENTO.VL_PAGAMENTO@">VL_PAGAMENTO_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_ESTRUTURA_COMISSAO.PAGAMENTO.VL_PAGAMENTO@",
                campo: "VL_PAGAMENTO_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados da Entrada",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados da Entrada" value="@UTIL.ENTRADA.INICIO@">INICIO_ENTRADA</a>',
                parametro: "@UTIL.ENTRADA.INICIO@",
                campo: "INICIO_ENTRADA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados da Entrada" value="@UTIL.ENTRADA.FIM@">FIM_ENTRADA</a>',
                parametro: "@UTIL.ENTRADA.FIM@",
                campo: "FIM_ENTRADA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas da Entrada" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total da Entrada" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Entrada" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VL_TOTAL@">VL_TOTAL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VL_TOTAL@",
                campo: "VL_TOTAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Entrada - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VL_PARCELA_COMISSAO@">VALOR_ENTRADA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VL_PARCELA_COMISSAO@",
                campo: "VALOR_ENTRADA_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela da Entrada" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela da Entrada" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela da Entrada" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento da Entrada" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros da Entrada" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela da Entrada - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ENTRADA.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados das Mensais",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados das Mensais" value="@UTIL.MENSAIS.INICIO@">INICIO_MENSAIS</a>',
                parametro: "@UTIL.MENSAIS.INICIO@",
                campo: "INICIO_MENSAIS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados das Mensais" value="@UTIL.MENSAIS.FIM@">FIM_MENSAIS</a>',
                parametro: "@UTIL.MENSAIS.FIM@",
                campo: "FIM_MENSAIS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas das Mensais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total das Mensais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das Mensais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas Mensais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VALOR_TOTAL_PARCELA@">VALOR_TOTAL_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VALOR_TOTAL_PARCELA@",
                campo: "VALOR_TOTAL_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas Mensais - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VL_PARCELA_COMISSAO@">VALOR_MENSAIS_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VL_PARCELA_COMISSAO@",
                campo: "VALOR_MENSAIS_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela das Mensais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela das Mensais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento das Mensais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros das Mensais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das Mensais - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.MENSAIS.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados das Anuais",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados das Anuais" value="@UTIL.ANUAIS.INICIO@">INICIO_ANUAIS</a>',
                parametro: "@UTIL.ANUAIS.INICIO@",
                campo: "INICIO_ANUAIS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados das Anuais" value="@UTIL.ANUAIS.FIM@">FIM_ANUAIS</a>',
                parametro: "@UTIL.ANUAIS.FIM@",
                campo: "FIM_ANUAIS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas das Anuais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total das Anuais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das Anuais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas Anuais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VALOR_PARCELA_TOTAL@">VALOR_PARCELA_TOTAL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VALOR_PARCELA_TOTAL@",
                campo: "VALOR_PARCELA_TOTAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas Anuais - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VL_PARCELA_COMISSAO@">VALOR_ANUAIS_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VL_PARCELA_COMISSAO@",
                campo: "VALOR_ANUAIS_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela das Anuais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela das Anuais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento das Anuais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros das Anuais" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das Anuais - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.ANUAIS.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados do Sinal",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SINAL.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SINAL.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Sinal" value="@UTIL.SINAL.INICIO@">INICIO_SINAL</a>',
                parametro: "@UTIL.SINAL.INICIO@",
                campo: "INICIO_SINAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Sinal" value="@UTIL.SINAL.FIM@">FIM_SINAL</a>',
                parametro: "@UTIL.SINAL.FIM@",
                campo: "FIM_SINAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Sinal da Proposta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_SINAL@">VL_TOTAL_SINAL</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_SINAL@",
                campo: "VL_TOTAL_SINAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Sinal - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SINAL.VL_PARCELA_COMISSAO@">VALOR_SINAL_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SINAL.VL_PARCELA_COMISSAO@",
                campo: "VALOR_SINAL_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Percentual do Sinal da Proposta" value="@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_SINAL@">%_SINAL</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_PERCENTUAL_SINAL@",
                campo: "%_SINAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso do Sinal da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_SINAL@">VL_TOTAL_SINAL_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_SINAL@",
                campo: "VL_TOTAL_SINAL_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento do Sinal" value="@TB_CMCRM_PROPOSTA.SINAL.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_VENCIMENTO_SINAL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.SINAL.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_VENCIMENTO_SINAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SINAL.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SINAL.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela do Sinal - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SINAL.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SINAL.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados Unicas",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados das UNICAS" value="@UTIL.UNICAS.INICIO@">INICIO_UNICAS</a>',
                parametro: "@UTIL.UNICAS.INICIO@",
                campo: "INICIO_UNICAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados das UNICAS" value="@UTIL.UNICAS.FIM@">FIM_UNICAS</a>',
                parametro: "@UTIL.UNICAS.FIM@",
                campo: "FIM_UNICAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas das UNICAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total das UNICAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das UNICAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas UNICAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VALOR_TOTAL_PARCELA@">VALOR_TOTAL_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VALOR_TOTAL_PARCELA@",
                campo: "VALOR_TOTAL_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas Únicas - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VL_PARCELA_COMISSAO@">VALOR_UNICAS_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VL_PARCELA_COMISSAO@",
                campo: "VALOR_UNICAS_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela das UNICAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela das UNICAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento das UNICAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros das UNICAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Única - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.UNICAS.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados Semestrais",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados das SEMESTRAIS" value="@UTIL.SEMESTRAIS.INICIO@">INICIO_SEMESTRAIS</a>',
                parametro: "@UTIL.SEMESTRAIS.INICIO@",
                campo: "INICIO_SEMESTRAIS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados das SEMESTRAIS" value="@UTIL.SEMESTRAIS.FIM@">FIM_SEMESTRAIS</a>',
                parametro: "@UTIL.SEMESTRAIS.FIM@",
                campo: "FIM_SEMESTRAIS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas das SEMESTRAIS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total das SEMESTRAIS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das SEMESTRAIS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcela SEMESTRAIS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VALOR_TOTAL_PARCELA@">VALOR_TOTAL_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VALOR_TOTAL_PARCELA@",
                campo: "VALOR_TOTAL_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas Semestrais - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VL_PARCELA_COMISSAO@">VALOR_SEMESTRAIS_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VL_PARCELA_COMISSAO@",
                campo: "VALOR_SEMESTRAIS_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela das SEMESTRAIS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela das SEMESTRAIS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento das SEMESTRAIS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros das SEMESTRAIS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Semestral - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SEMESTRAIS.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados Trimestral",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados das TRIMESTRAL" value="@UTIL.TRIMESTRAL.INICIO@">INICIO_TRIMESTRAL</a>',
                parametro: "@UTIL.TRIMESTRAL.INICIO@",
                campo: "INICIO_TRIMESTRAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados das TRIMESTRAL" value="@UTIL.TRIMESTRAL.FIM@">FIM_TRIMESTRAL</a>',
                parametro: "@UTIL.TRIMESTRAL.FIM@",
                campo: "FIM_TRIMESTRAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas das TRIMESTRAL" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total das TRIMESTRAL" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das TRIMESTRAL" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcela TRIMESTRAL" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VALOR_TOTAL_PARCELA@">VALOR_TOTAL_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VALOR_TOTAL_PARCELA@",
                campo: "VALOR_TOTAL_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas Trimestrais - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VL_PARCELA_COMISSAO@">VALOR_TRIMESTRAL_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VL_PARCELA_COMISSAO@",
                campo: "VALOR_TRIMESTRAL_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela das TRIMESTRAL" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela das TRIMESTRAL" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento das TRIMESTRAL" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros das TRIMESTRAL" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Trimestral - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.TRIMESTRAL.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados Intermediarias",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados das INTERMEDIARIAS" value="@UTIL.INTERMEDIARIAS.INICIO@">INICIO_INTERMEDIARIAS</a>',
                parametro: "@UTIL.INTERMEDIARIAS.INICIO@",
                campo: "INICIO_INTERMEDIARIAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados das INTERMEDIARIAS" value="@UTIL.INTERMEDIARIAS.FIM@">FIM_INTERMEDIARIAS</a>',
                parametro: "@UTIL.INTERMEDIARIAS.FIM@",
                campo: "FIM_INTERMEDIARIAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas das INTERMEDIARIAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total das INTERMEDIARIAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das INTERMEDIARIAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcela INTERMEDIARIAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VALOR_TOTAL_PARCELA@">VALOR_TOTAL_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VALOR_TOTAL_PARCELA@",
                campo: "VALOR_TOTAL_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas Intermediárias - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VL_PARCELA_COMISSAO@">VALOR_INTERMEDIARIAS_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VL_PARCELA_COMISSAO@",
                campo: "VALOR_INTERMEDIARIAS_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela das INTERMEDIARIAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela das INTERMEDIARIAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento das INTERMEDIARIAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros das INTERMEDIARIAS" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Intermediária - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.INTERMEDIARIAS.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados do Fin. Direto",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Financiamento Direto da Proposta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_FIN_DIRETO@">VL_TOTAL_FIN_DIRETO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_FIN_DIRETO@",
                campo: "VL_TOTAL_FIN_DIRETO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso do Financiamento Direto da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_FIN_DIRETO@">VL_TOTAL_FIN_DIRETO_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_FIN_DIRETO@",
                campo: "VL_TOTAL_FIN_DIRETO_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento do Financiamento Direto da Proposta" value="@TB_CMCRM_PROPOSTA.FIN_DIRETO.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_VENCIMENTO_FIN_DIR</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.FIN_DIRETO.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_VENCIMENTO_FIN_DIR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas do Financiamento Direto da Proposta" value="@TB_CMCRM_PROPOSTA.FIN_DIRETO.NR_QUANTIDADE_PARCELAS@">NR_PARCELAS_FIN_DIR</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.FIN_DIRETO.NR_QUANTIDADE_PARCELAS@",
                campo: "NR_PARCELAS_FIN_DIR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela do Financiamento Direto da Proposta" value="@TB_CMCRM_PROPOSTA.FIN_DIRETO.VALOR_PARCELA@">VL_PARCELA_FIN_DIR</a>',
                parametro: "@TB_CMCRM_PROPOSTA.FIN_DIRETO.VALOR_PARCELA@",
                campo: "VL_PARCELA_FIN_DIR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total da Parcela do Financiamento Direto" value="@TB_CMCRM_PROPOSTA.FIN_DIRETO.VALOR_TOTAL_PARCELA@">VL_TOTAL_PARCELA</a>',
                parametro: "@TB_CMCRM_PROPOSTA.FIN_DIRETO.VALOR_TOTAL_PARCELA@",
                campo: "VL_TOTAL_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas do Financiamento Direto - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FIN_DIRETO.VL_PARCELA_COMISSAO@">VALOR_FIN_DIRETO_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FIN_DIRETO.VL_PARCELA_COMISSAO@",
                campo: "VALOR_FIN_DIRETO_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FIN_DIRETO.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FIN_DIRETO.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Financiamento Direto - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FIN_DIRETO.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FIN_DIRETO.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados do Financiamento",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Financiamento" value="@UTIL.FINANCIAMENTO.INICIO@">INICIO_FINANCIAMENTO</a>',
                parametro: "@UTIL.FINANCIAMENTO.INICIO@",
                campo: "INICIO_FINANCIAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Financiamento" value="@UTIL.FINANCIAMENTO.FIM@">FIM_FINANCIAMENTO</a>',
                parametro: "@UTIL.FINANCIAMENTO.FIM@",
                campo: "FIM_FINANCIAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Financiamento da Proposta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_FINANCIAMENTO@">VL_TOTAL_FIN</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_FINANCIAMENTO@",
                campo: "VL_TOTAL_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso do Financiamento da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_FINANCIAMENTO@">VL_TOTAL_FIN_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_FINANCIAMENTO@",
                campo: "VL_TOTAL_FIN_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas do Financiamento - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.VL_PARCELA_COMISSAO@">VALOR_FINANCIAMENTO_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.VL_PARCELA_COMISSAO@",
                campo: "VALOR_FINANCIAMENTO_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento do Financiamento da Proposta" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_VENCIMENTO_FIN</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_VENCIMENTO_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas do Financiamento da Proposta" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.NR_QUANTIDADE_PARCELAS@">NR_PARCELAS_FIN</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.NR_QUANTIDADE_PARCELAS@",
                campo: "NR_PARCELAS_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela do Financiamento da Proposta" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.VALOR_PARCELA@">VL_PARCELA_FIN</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.VALOR_PARCELA@",
                campo: "VL_PARCELA_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Indicador de Parcelas Fixas ou Reajustáveis" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.FL_REAJUSTAVEL@">FL_REAJUSTAVEL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.FL_REAJUSTAVEL@",
                campo: "FL_REAJUSTAVEL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Financiamento - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FINANCIAMENTO.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados do FGTS",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do FGTS" value="@UTIL.FGTS.INICIO@">INICIO_FGTS</a>',
                parametro: "@UTIL.FGTS.INICIO@",
                campo: "INICIO_FGTS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do FGTS" value="@UTIL.FGTS.FIM@">FIM_FGTS</a>',
                parametro: "@UTIL.FGTS.FIM@",
                campo: "FIM_FGTS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do FGTS da Proposta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_FGTS@">VL_TOTAL_FGTS</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_FGTS@",
                campo: "VL_TOTAL_FGTS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcelas do FGTS - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FGTS.VL_PARCELA_COMISSAO@">VALOR_FGTS_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FGTS.VL_PARCELA_COMISSAO@",
                campo: "VALOR_FGTS_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso do FGTS da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_FGTS@">VL_TOTAL_FGTS_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_FGTS@",
                campo: "VL_TOTAL_FGTS_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento do FGTS da Proposta" value="@TB_CMCRM_PROPOSTA.FGTS.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_VENCIMENTO_FGTS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.FGTS.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_VENCIMENTO_FGTS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas do FGTS da Proposta" value="@TB_CMCRM_PROPOSTA.FGTS.NR_QUANTIDADE_PARCELAS@">NR_PARCELAS_FGTS</a>',
                parametro: "@TB_CMCRM_PROPOSTA.FGTS.NR_QUANTIDADE_PARCELAS@",
                campo: "NR_PARCELAS_FGTS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela do FGTS da Proposta" value="@TB_CMCRM_PROPOSTA.FGTS.VALOR_PARCELA@">VL_PARCELA_FGTS</a>',
                parametro: "@TB_CMCRM_PROPOSTA.FGTS.VALOR_PARCELA@",
                campo: "VL_PARCELA_FGTS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela FGTS - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FGTS.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.FGTS.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados do Subsídio",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Subsídio da Proposta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_SUBSIDIO@">VL_TOTAL_SUBSIDIO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_SUBSIDIO@",
                campo: "VL_TOTAL_SUBSIDIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Subsídio - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SUBSIDIO.VL_PARCELA_COMISSAO@">VALOR_SUBSIDIO_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SUBSIDIO.VL_PARCELA_COMISSAO@",
                campo: "VALOR_SUBSIDIO_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso do Subsídio da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_SUBSIDIO@">VL_TOTAL_SUBSIDIO_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_SUBSIDIO@",
                campo: "VL_TOTAL_SUBSIDIO_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento do Subsídio da Proposta" value="@TB_CMCRM_PROPOSTA.SUBSIDIO.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_VENCIMENTO_SUBSIDIO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.SUBSIDIO.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_VENCIMENTO_SUBSIDIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas do Subsídio da Proposta" value="@TB_CMCRM_PROPOSTA.SUBSIDIO.NR_QUANTIDADE_PARCELAS@">NR_PARCELAS_SUBSIDIO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.SUBSIDIO.NR_QUANTIDADE_PARCELAS@",
                campo: "NR_PARCELAS_SUBSIDIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela do Subsídio da Proposta" value="@TB_CMCRM_PROPOSTA.SUBSIDIO.VALOR_PARCELA@">VL_PARCELA_SUBSIDIO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.SUBSIDIO.VALOR_PARCELA@",
                campo: "VL_PARCELA_SUBSIDIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Subsídio - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SUBSIDIO.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.SUBSIDIO.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados do Bônus",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do BÔNUS" value="@UTIL.VL_TOTAL_BONUS.INICIO@">INICIO_VL_TOTAL_BONUS</a>',
                parametro: "@UTIL.VL_TOTAL_BONUS.INICIO@",
                campo: "INICIO_VL_TOTAL_BONUS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim do dados do BÔNUS" value="@UTIL.VL_TOTAL_BONUS.FIM@">FIM_VL_TOTAL_BONUS</a>',
                parametro: "@UTIL.VL_TOTAL_BONUS.FIM@",
                campo: "FIM_VL_TOTAL_BONUS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Bônus da Proposta" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_BONUS@">VL_TOTAL_BONUS</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_BONUS@",
                campo: "VL_TOTAL_BONUS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Bônus - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.BONUS.VL_PARCELA_COMISSAO@">VALOR_BONUS_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.BONUS.VL_PARCELA_COMISSAO@",
                campo: "VALOR_BONUS_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso do Bônus da Proposta" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_BONUS@">VL_TOTAL_BONUS_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_BONUS@",
                campo: "VL_TOTAL_BONUS_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento do Bônus da Proposta" value="@TB_CMCRM_PROPOSTA.BONUS.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_VENCIMENTO_BONUS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.BONUS.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_VENCIMENTO_BONUS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas do Bônus da Proposta" value="@TB_CMCRM_PROPOSTA.BONUS.NR_QUANTIDADE_PARCELAS@">NR_PARCELAS_BONUS</a>',
                parametro: "@TB_CMCRM_PROPOSTA.BONUS.NR_QUANTIDADE_PARCELAS@",
                campo: "NR_PARCELAS_BONUS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela do Bônus da Proposta" value="@TB_CMCRM_PROPOSTA.BONUS.VALOR_PARCELA@">VL_PARCELA_BONUS</a>',
                parametro: "@TB_CMCRM_PROPOSTA.BONUS.VALOR_PARCELA@",
                campo: "VL_PARCELA_BONUS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Bônus - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.BONUS.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.BONUS.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados do Pró Soluto",
        repeticao: true,
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Pró Soluto" value="@UTIL.PRO_SOLUTO.INICIO@">INICIO_PRO_SOLUTO</a>',
                parametro: "@UTIL.PRO_SOLUTO.INICIO@",
                campo: "INICIO_PRO_SOLUTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Pró Soluto" value="@UTIL.PRO_SOLUTO.FIM@">FIM_PRO_SOLUTO</a>',
                parametro: "@UTIL.PRO_SOLUTO.FIM@",
                campo: "FIM_PRO_SOLUTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total de Pró Soluto" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_PRO_SOLUTO@">VL_TOTAL_PRO_SOLUTO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_PRO_SOLUTO@",
                campo: "VL_TOTAL_PRO_SOLUTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total do Pró Soluto - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VL_PARCELA_COMISSAO@">VALOR_PRO_SOLUTO_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VL_PARCELA_COMISSAO@",
                campo: "VALOR_PRO_SOLUTO_COMISSAO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso de Pró Soluto" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_PRO_SOLUTO@">VL_TOTAL_PRO_SOLUTO_EXTENSO</a>',
                parametro: "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_PRO_SOLUTO@",
                campo: "VL_TOTAL_PRO_SOLUTO_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total de Pró Soluto Capitalizado" value="@TB_CMCRM_PROPOSTA.VL_TOTAL_PRO_SOLUTO_CAP@">VL_TOTAL_PRO_SOLUTO_CAP</a>',
                parametro: "@TB_CMCRM_PROPOSTA.VL_TOTAL_PRO_SOLUTO_CAP@",
                campo: "VL_TOTAL_PRO_SOLUTO_CAP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total por Extenso de Pró Soluto Capitalizado" value="@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_PRO_SOLUTO_CAP@">VL_TOTAL_PRO_SOLUTO_EXTENSO_CAP</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA.EXTENSO.VL_TOTAL_PRO_SOLUTO_CAP@",
                campo: "VL_TOTAL_PRO_SOLUTO_EXTENSO_CAP",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quantidade de Parcelas das Pró Soluto" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.NR_QUANTIDADE_PARCELAS@">QTD_PARCELAS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.NR_QUANTIDADE_PARCELAS@",
                campo: "QTD_PARCELAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Percentual Total das Pró Soluto" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VL_PERCENTUAL_SERIE@">%_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VL_PERCENTUAL_SERIE@",
                campo: "%_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela das Pró Soluto" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VALOR_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VALOR_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total das Parcela Pró Soluto" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VALOR_PARCELA_TOTAL@">VALOR_PARCELA_TOTAL</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VALOR_PARCELA_TOTAL@",
                campo: "VALOR_PARCELA_TOTAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Primeira Parcela das Pró Soluto" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.DT_VENCIMENTO_PRIMEIRA_PARCELA@">DT_PRIMEIRO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.DT_VENCIMENTO_PRIMEIRA_PARCELA@",
                campo: "DT_PRIMEIRO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data de Vencimento da Última Parcela das Pró Soluto" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.DT_ULTIMO_VENCIMENTO@">DT_ULTIMO_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.DT_ULTIMO_VENCIMENTO@",
                campo: "DT_ULTIMO_VENCIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Forma de Pagamento das Pró Soluto" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.DS_TIPO_FORMA_PAGAMENTO@">DS_FORMA_PAGAMENTO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.DS_TIPO_FORMA_PAGAMENTO@",
                campo: "DS_FORMA_PAGAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Taxa de Juros das Pró Soluto" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VL_TAXA_JUROS@">%_JUROS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VL_TAXA_JUROS@",
                campo: "%_JUROS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Tipo de Parcela" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.DS_TIPO_PARCELA@">TIPO PARCELA</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.DS_TIPO_PARCELA@",
                campo: "DS_TIPO_PARCELA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Parcela Pró Soluto - Comissão" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VALOR_PARCELA_COMISSAO@">VALOR_PARCELA_COMISSAO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.PRO_SOLUTO.VALOR_PARCELA_COMISSAO@",
                campo: "VALOR_PARCELA_COMISSAO",
            },
        ],
    },
    {
        titleHtml: "Dados do Repasse",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Financiamento" value="@UTIL.FINANCIAMENTO.INICIO@">INICIO_FINANCIAMENTO</a>',
                parametro: "@UTIL.FINANCIAMENTO.INICIO@",
                campo: "INICIO_FINANCIAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Financiamento" value="@UTIL.FINANCIAMENTO.FIM@">FIM_FINANCIAMENTO</a>',
                parametro: "@UTIL.FINANCIAMENTO.FIM@",
                campo: "FIM_FINANCIAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Financiamento Cadastrado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_FINANCIAMENTO@">VL_FINANCIAMENTO</a>',
                parametro: "@TB_CMCRM_CASO_REPASSE_DADOS.VL_FINANCIAMENTO@",
                campo: "VL_FINANCIAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Financiamento Confirmado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_FINANCIAMENTO_CONFIRMADO@">VL_FINANCIAMENTO_CONFIRMADO</a>',
                parametro:
                    "@TB_CMCRM_CASO_REPASSE_DADOS.VL_FINANCIAMENTO_CONFIRMADO@",
                campo: "VL_FINANCIAMENTO_CONFIRMADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Diferença entre Financiamento Confirmado e Cadastrado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_FINANCIAMENTO_DIFERENCA@">VL_DIFERENCA_FIN</a>',
                parametro:
                    "@TB_CMCRM_CASO_REPASSE_DADOS.VL_FINANCIAMENTO_DIFERENCA@",
                campo: "VL_DIFERENCA_FIN",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de FGTS Cadastrado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_FGTS@">VL_FGTS</a>',
                parametro: "@TB_CMCRM_CASO_REPASSE_DADOS.VL_FGTS@",
                campo: "VL_FGTS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de FGTS Confirmado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_FGTS_CONFIRMADO@">VL_FGTS_CONFIRMADO</a>',
                parametro: "@TB_CMCRM_CASO_REPASSE_DADOS.VL_FGTS_CONFIRMADO@",
                campo: "VL_FGTS_CONFIRMADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Diferença entre FGTS Confirmado e Cadastrado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_FGTS_DIFERENCA@">VL_DIFERENCA_FGTS</a>',
                parametro: "@TB_CMCRM_CASO_REPASSE_DADOS.VL_FGTS_DIFERENCA@",
                campo: "VL_DIFERENCA_FGTS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Subsídio Cadastrado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_SUBSIDIO@">VL_SUBSIDIO</a>',
                parametro: "@TB_CMCRM_CASO_REPASSE_DADOS.VL_SUBSIDIO@",
                campo: "VL_SUBSIDIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor de Subsídio Confirmado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_SUBSIDIO_CONFIRMADO@">VL_SUBSIDIO_CONFIRMADO</a>',
                parametro:
                    "@TB_CMCRM_CASO_REPASSE_DADOS.VL_SUBSIDIO_CONFIRMADO@",
                campo: "VL_SUBSIDIO_CONFIRMADO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor da Diferença entre Subsídio Confirmado e Cadastrado" value="@TB_CMCRM_CASO_REPASSE_DADOS.VL_SUBSIDIO_DIFERENCA@">VL_DIFERENCA_SUB</a>',
                parametro:
                    "@TB_CMCRM_CASO_REPASSE_DADOS.VL_SUBSIDIO_DIFERENCA@",
                campo: "VL_DIFERENCA_SUB",
            },
        ],
    },
    {
        titleHtml: "Dados do Corretor",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Corretor" value="@UTIL.CORRETOR.INICIO@">INICIO_CORRETOR</a>',
                parametro: "@UTIL.CORRETOR.INICIO@",
                campo: "INICIO_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Corretor" value="@UTIL.CORRETOR.FIM@">FIM_CORRETOR</a>',
                parametro: "@UTIL.CORRETOR.FIM@",
                campo: "FIM_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_NOME@">NOME_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_NOME@",
                campo: "NOME_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_RG@">RG_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_RG@",
                campo: "RG_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_CPF@">CPF/CNPJ_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_CPF@",
                campo: "CPF/CNPJ_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CRECI do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_CRECI@">CRECI_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_CRECI@",
                campo: "CRECI_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_EMAIL@">EMAIL_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_EMAIL@",
                campo: "EMAIL_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Corretor" value="@TB_CMC_USUARIO.CORRETOR.NR_TELEFONE@">TELEFONE_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.NR_TELEFONE@",
                campo: "TELEFONE_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome de Importação do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_NOME_IMPORTACAO@">NOME_IMP_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_NOME_IMPORTACAO@",
                campo: "NOME_IMP_CORRETOR",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_LOGRADOURO@">ENDERECO_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_LOGRADOURO@",
                campo: "ENDERECO_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Corretor" value="@TB_CMC_USUARIO.CORRETOR.NR_ENDERECO@">NR_ENDERECO_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.NR_ENDERECO@",
                campo: "NR_ENDERECO_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO_ENDERECO_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO_ENDERECO_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_BAIRRO@">BAIRRO_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_BAIRRO@",
                campo: "BAIRRO_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_CIDADE@">CIDADE_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_CIDADE@",
                campo: "CIDADE_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Corretor" value="@TB_CMC_USUARIO.CORRETOR.DS_ESTADO@">ESTADO_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.DS_ESTADO@",
                campo: "ESTADO_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Corretor" value="@TB_CMC_USUARIO.CORRETOR.NR_CEP@">CEP_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.NR_CEP@",
                campo: "CEP_CORRETOR",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF/CNPJ de Importação do Corretor" value="@TB_CMC_USUARIO.CORRETOR.NR_CPF_IMPORTACAO@">CPF_IMPORTACAO_CORRETOR</a>',
                parametro: "@TB_CMC_USUARIO.CORRETOR.NR_CPF_IMPORTACAO@",
                campo: "CPF_IMPORTACAO_CORRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Corretor" value="@ASSINATURA.TB_CMC_USUARIO.CORRETOR.ID_USUARIO@">ASSINATURA_CORRETOR</a>',
                parametro: "@ASSINATURA.TB_CMC_USUARIO.CORRETOR.ID_USUARIO@",
                campo: "ASSINATURA_CORRETOR",
            },
        ],
    },

    {
        titleHtml: "Dados do Gerente Comercial ",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Gerente Comercial" value="@UTIL.GERENTE_COMERCIAL.INICIO@">INICIO_GERENTE_COMERCIAL</a>',
                parametro: "@UTIL.GERENTE_COMERCIAL.INICIO@",
                campo: "INICIO_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Gerente Comercial" value="@UTIL.GERENTE_COMERCIAL.FIM@">FIM_GERENTE_COMERCIAL</a>',
                parametro: "@UTIL.GERENTE_COMERCIAL.FIM@",
                campo: "FIM_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_NOME@">NOME_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_NOME@",
                campo: "NOME_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_RG@">RG_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_RG@",
                campo: "RG_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_CPF@">CPF/CNPJ_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_CPF@",
                campo: "CPF/CNPJ_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CRECI do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_CRECI@">CRECI_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_CRECI@",
                campo: "CRECI_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_EMAIL@">EMAIL_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_EMAIL@",
                campo: "EMAIL_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.NR_TELEFONE@">TELEFONE_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.NR_TELEFONE@",
                campo: "TELEFONE_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Gerente Comercial" value="@ASSINATURA.TB_CMC_USUARIO.GERENTE_COMERCIAL.ID_USUARIO@">ASSINATURA_GERENTE_COMERCIAL</a>',
                parametro:
                    "@ASSINATURA.TB_CMC_USUARIO.GERENTE_COMERCIAL.ID_USUARIO@",
                campo: "ASSINATURA_GERENTE_COMERCIAL",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_LOGRADOURO@">ENDERECO_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_LOGRADOURO@",
                campo: "ENDERECO_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.NR_ENDERECO@">NR_ENDERECO_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.NR_ENDERECO@",
                campo: "NR_ENDERECO_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO_ENDERECO_GERENTE_COMERCIAL</a>',
                parametro:
                    "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_BAIRRO@">BAIRRO_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_BAIRRO@",
                campo: "BAIRRO_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_CIDADE@">CIDADE_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_CIDADE@",
                campo: "CIDADE_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_ESTADO@">ESTADO_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_ESTADO@",
                campo: "ESTADO_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.NR_CEP@">CEP_GERENTE_COMERCIAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_COMERCIAL.NR_CEP@",
                campo: "CEP_GERENTE_COMERCIAL",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome de Importação do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_NOME_IMPORTACAO@">NOME_IMP_GERENTE_COMERCIAL</a>',
                parametro:
                    "@TB_CMC_USUARIO.GERENTE_COMERCIAL.DS_NOME_IMPORTACAO@",
                campo: "NOME_IMP_GERENTE_COMERCIAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF/CNPJ de Importação do Gerente Comercial" value="@TB_CMC_USUARIO.GERENTE_COMERCIAL.NR_CPF_IMPORTACAO@">CPF_IMPORTACAO_GERENTE_COMERCIAL</a>',
                parametro:
                    "@TB_CMC_USUARIO.GERENTE_COMERCIAL.NR_CPF_IMPORTACAO@",
                campo: "CPF_IMPORTACAO_GERENTE_COMERCIAL",
            },
        ],
    },

    {
        titleHtml: "Dados do Gerente de Vendas ",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Gerente de Vendas" value="@UTIL.GERENTE_VENDAS.INICIO@">INICIO_GERENTE_VENDAS</a>',
                parametro: "@UTIL.GERENTE_VENDAS.INICIO@",
                campo: "INICIO_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Gerente de Vendas" value="@UTIL.GERENTE_VENDAS.FIM@">FIM_GERENTE_VENDAS</a>',
                parametro: "@UTIL.GERENTE_VENDAS.FIM@",
                campo: "FIM_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_NOME@">NOME_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_NOME@",
                campo: "NOME_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_RG@">RG_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_RG@",
                campo: "RG_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_CPF@">CPF/CNPJ_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_CPF@",
                campo: "CPF/CNPJ_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CRECI do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_CRECI@">CRECI_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_CRECI@",
                campo: "CRECI_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_EMAIL@">EMAIL_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_EMAIL@",
                campo: "EMAIL_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.NR_TELEFONE@">TELEFONE_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.NR_TELEFONE@",
                campo: "TELEFONE_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Gerente de Vendas" value="@ASSINATURA.TB_CMC_USUARIO.GERENTE_VENDAS.ID_USUARIO@">ASSINATURA_GERENTE_VENDAS</a>',
                parametro:
                    "@ASSINATURA.TB_CMC_USUARIO.GERENTE_VENDAS.ID_USUARIO@",
                campo: "ASSINATURA_GERENTE_VENDAS",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_LOGRADOURO@">ENDERECO_GERENTE_VENDA</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_LOGRADOURO@",
                campo: "ENDERECO_GERENTE_VENDA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.NR_ENDERECO@">NR_ENDERECO_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.NR_ENDERECO@",
                campo: "NR_ENDERECO_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO_ENDERECO_GERENTE_VENDAS</a>',
                parametro:
                    "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO_ENDERECO_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_BAIRRO@">BAIRRO_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_BAIRRO@",
                campo: "BAIRRO_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_CIDADE@">CIDADE_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_CIDADE@",
                campo: "CIDADE_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_ESTADO@">ESTADO_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_ESTADO@",
                campo: "ESTADO_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.NR_CEP@">CEP_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.NR_CEP@",
                campo: "CEP_GERENTE_VENDAS",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome de Importação do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.DS_NOME_IMPORTACAO@">NOME_IMP_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.DS_NOME_IMPORTACAO@",
                campo: "NOME_IMP_GERENTE_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF/CNPJ de Importação do Gerente de Vendas" value="@TB_CMC_USUARIO.GERENTE_VENDAS.NR_CPF_IMPORTACAO@">CPF_IMPORTACAO_GERENTE_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_VENDAS.NR_CPF_IMPORTACAO@",
                campo: "CPF_IMPORTACAO_GERENTE_VENDAS",
            },
        ],
    },
    {
        titleHtml: "Dados do Gerente Regional",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Gerente Regional" value="@UTIL.GERENTE_REGIONAL.INICIO@">INICIO_GERENTE_REGIONAL</a>',
                parametro: "@UTIL.GERENTE_REGIONAL.INICIO@",
                campo: "INICIO_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Gerente Regional" value="@UTIL.GERENTE_REGIONAL.FIM@">FIM_GERENTE_REGIONAL</a>',
                parametro: "@UTIL.GERENTE_REGIONAL.FIM@",
                campo: "FIM_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_NOME@">NOME_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_NOME@",
                campo: "NOME_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_RG@">RG_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_RG@",
                campo: "RG_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_CPF@">CPF/CNPJ_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_CPF@",
                campo: "CPF/CNPJ_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CRECI do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_CRECI@">CRECI_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_CRECI@",
                campo: "CRECI_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_EMAIL@">EMAIL_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_EMAIL@",
                campo: "EMAIL_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.NR_TELEFONE@">TELEFONE_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.NR_TELEFONE@",
                campo: "TELEFONE_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Gerente Regional" value="@ASSINATURA.TB_CMC_USUARIO.GERENTE_REGIONAL.ID_USUARIO@">ASSINATURA_GERENTE_REGIONAL</a>',
                parametro:
                    "@ASSINATURA.TB_CMC_USUARIO.GERENTE_REGIONAL.ID_USUARIO@",
                campo: "ASSINATURA_GERENTE_REGIONAL",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_LOGRADOURO@">ENDERECO_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_LOGRADOURO@",
                campo: "ENDERECO_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.NR_ENDERECO@">NR_ENDERECO_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.NR_ENDERECO@",
                campo: "NR_ENDERECO_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO_ENDERECO_GERENTE_REGIONAL</a>',
                parametro:
                    "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_BAIRRO@">BAIRRO_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_BAIRRO@",
                campo: "BAIRRO_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_CIDADE@">CIDADE_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_CIDADE@",
                campo: "CIDADE_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_ESTADO@">ESTADO_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_ESTADO@",
                campo: "ESTADO_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.NR_CEP@">CEP_GERENTE_REGIONAL</a>',
                parametro: "@TB_CMC_USUARIO.GERENTE_REGIONAL.NR_CEP@",
                campo: "CEP_GERENTE_REGIONAL",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome de Importação do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_NOME_IMPORTACAO@">NOME_IMP_GERENTE_REGIONAL</a>',
                parametro:
                    "@TB_CMC_USUARIO.GERENTE_REGIONAL.DS_NOME_IMPORTACAO@",
                campo: "NOME_IMP_GERENTE_REGIONAL",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF/CNPJ de Importação do Gerente Regional" value="@TB_CMC_USUARIO.GERENTE_REGIONAL.NR_CPF_IMPORTACAO@">CPF_IMPORTACAO_GERENTE_REGIONAL</a>',
                parametro:
                    "@TB_CMC_USUARIO.GERENTE_REGIONAL.NR_CPF_IMPORTACAO@",
                campo: "CPF_IMPORTACAO_GERENTE_REGIONAL",
            },
        ],
    },
    {
        titleHtml: "Dados do Coord. de Vendas",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Coord. de Vendas" value="@UTIL.COORDENADOR_VENDAS.INICIO@">INICIO_COORD_VENDAS</a>',
                parametro: "@UTIL.COORDENADOR_VENDAS.INICIO@",
                campo: "INICIO_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Coord. de Vendas" value="@UTIL.COORDENADOR_VENDAS.FIM@">FIM_COORD_VENDAS</a>',
                parametro: "@UTIL.COORDENADOR_VENDAS.FIM@",
                campo: "FIM_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_NOME@">NOME_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_NOME@",
                campo: "NOME_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_RG@">RG_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_RG@",
                campo: "RG_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_CPF@">CPF/CNPJ_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_CPF@",
                campo: "CPF/CNPJ_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CRECI do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_CRECI@">CRECI_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_CRECI@",
                campo: "CRECI_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_EMAIL@">EMAIL_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_EMAIL@",
                campo: "EMAIL_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.NR_TELEFONE@">TELEFONE_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.NR_TELEFONE@",
                campo: "TELEFONE_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Coord. de Vendas" value="@ASSINATURA.TB_CMC_USUARIO.COORDENADOR_VENDAS.ID_USUARIO@">ASSINATURA_COORD_VENDAS</a>',
                parametro:
                    "@ASSINATURA.TB_CMC_USUARIO.COORDENADOR_VENDAS.ID_USUARIO@",
                campo: "ASSINATURA_COORD_VENDAS",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_LOGRADOURO@">ENDERECO_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_LOGRADOURO@",
                campo: "ENDERECO_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.NR_ENDERECO@">NR_ENDERECO_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.NR_ENDERECO@",
                campo: "NR_ENDERECO_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO_ENDERECO_COORD_VENDAS</a>',
                parametro:
                    "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_BAIRRO@">BAIRRO_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_BAIRRO@",
                campo: "BAIRRO_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_CIDADE@">CIDADE_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_CIDADE@",
                campo: "CIDADE_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_ESTADO@">ESTADO_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_ESTADO@",
                campo: "ESTADO_COORD_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Coord. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.NR_CEP@">CEP_COORD_VENDAS</a>',
                parametro: "@TB_CMC_USUARIO.COORDENADOR_VENDAS.NR_CEP@",
                campo: "CEP_COORD_VENDAS",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome de Importação do Cood. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_NOME_IMPORTACAO@">NOME_IMP_COORDENADOR_VENDAS</a>',
                parametro:
                    "@TB_CMC_USUARIO.COORDENADOR_VENDAS.DS_NOME_IMPORTACAO@",
                campo: "NOME_IMP_COORDENADOR_VENDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF/CNPJ de Importação do Cood. de Vendas" value="@TB_CMC_USUARIO.COORDENADOR_VENDAS.NR_CPF_IMPORTACAO@">CPF_IMPORTACAO_COORDENADOR_VENDAS</a>',
                parametro:
                    "@TB_CMC_USUARIO.COORDENADOR_VENDAS.NR_CPF_IMPORTACAO@",
                campo: "CPF_IMPORTACAO_COORDENADOR_VENDAS",
            },
        ],
    },
    {
        titleHtml: "Dados do Diretor",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Diretor" value="@UTIL.DIRETOR.INICIO@">INICIO_DIRETOR</a>',
                parametro: "@UTIL.DIRETOR.INICIO@",
                campo: "INICIO_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Diretor" value="@UTIL.DIRETOR.FIM@">FIM_DIRETOR</a>',
                parametro: "@UTIL.DIRETOR.FIM@",
                campo: "FIM_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_NOME@">NOME_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_NOME@",
                campo: "NOME_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_RG@">RG_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_RG@",
                campo: "RG_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_CPF@">CPF/CNPJ_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_CPF@",
                campo: "CPF/CNPJ_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CRECI do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_CRECI@">CRECI_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_CRECI@",
                campo: "CRECI_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Email do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_EMAIL@">EMAIL_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_EMAIL@",
                campo: "EMAIL_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Telefone do Diretor" value="@TB_CMC_USUARIO.DIRETOR.NR_TELEFONE@">TELEFONE_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.NR_TELEFONE@",
                campo: "TELEFONE_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Diretor" value="@ASSINATURA.TB_CMC_USUARIO.DIRETOR.ID_USUARIO@">ASSINATURA_DIRETOR</a>',
                parametro: "@ASSINATURA.TB_CMC_USUARIO.DIRETOR.ID_USUARIO@",
                campo: "ASSINATURA_DIRETOR",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_LOGRADOURO@">ENDERECO_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_LOGRADOURO@",
                campo: "ENDERECO_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Endereço do Diretor" value="@TB_CMC_USUARIO.DIRETOR.NR_ENDERECO@">NR_ENDERECO_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.NR_ENDERECO@",
                campo: "NR_ENDERECO_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Complemento do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_COMPLEMENTO_ENDERECO@">COMPLEMENTO_ENDERECO_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_COMPLEMENTO_ENDERECO@",
                campo: "COMPLEMENTO_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Bairro do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_BAIRRO@">BAIRRO_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_BAIRRO@",
                campo: "BAIRRO_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Cidade do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_CIDADE@">CIDADE_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_CIDADE@",
                campo: "CIDADE_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Estado do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_ESTADO@">ESTADO_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_ESTADO@",
                campo: "ESTADO_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CEP do Diretor" value="@TB_CMC_USUARIO.DIRETOR.NR_CEP@">CEP_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.NR_CEP@",
                campo: "CEP_DIRETOR",
            },

            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome de Importação do Diretor" value="@TB_CMC_USUARIO.DIRETOR.DS_NOME_IMPORTACAO@">NOME_IMP_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.DS_NOME_IMPORTACAO@",
                campo: "NOME_IMP_DIRETOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF/CNPJ de Importação do Diretor" value="@TB_CMC_USUARIO.DIRETOR.NR_CPF_IMPORTACAO@">CPF_IMPORTACAO_DIRETOR</a>',
                parametro: "@TB_CMC_USUARIO.DIRETOR.NR_CPF_IMPORTACAO@",
                campo: "CPF_IMPORTACAO_DIRETOR",
            },
        ],
    },
    {
        titleHtml: "Dados Gerais",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Dia de Geração do Contrato" value="@DATA.DIA@">DIA</a>',
                parametro: "@DATA.DIA@",
                campo: "DIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Mês (Por Extenso) de Geração do Contrato" value="@DATA.MES_EXTENSO@">MÊS_EXTENSO</a>',
                parametro: "@DATA.MES_EXTENSO@",
                campo: "MÊS_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Mês (Numérico) de Geração do Contrato" value="@DATA.MES_NUM@">MÊS_NUMÉRICO</a>',
                parametro: "@DATA.MES_NUM@",
                campo: "MÊS_NUMÉRICO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Ano de Geração do Contrato" value="@DATA.ANO@">ANO</a>',
                parametro: "@DATA.ANO@",
                campo: "ANO",
            },
        ],
    },

    // ATENDIMENTO AO CLIENTE
    {
        titleHtml: "Dados Gerais",
        value: 1,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.DIA@">DIA</a>',
                parametro: "@TB_GERAL.DIA@",
                campo: "DIA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.DATA_COMPLETA@">DATA_COMPLETA</a>',
                parametro: "@TB_GERAL.DATA_COMPLETA@",
                campo: "DATA_COMPLETA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.USUARIO_LOGADO@">USUARIO_LOGADO</a>',
                parametro: "@TB_GERAL.USUARIO_LOGADO@",
                campo: "USUARIO_LOGADO",
            },
        ],
    },
    {
        titleHtml: "DADOS DO CLIENTE",
        value: 1,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Dia de Geração do Contrato" value="@TB_CMCRM_CONTA.DS_NOME@">NOME</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME@",
                campo: "NOME",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_NOME_1@">PRIMEIRO_NOME</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME_1@",
                campo: "PRIMEIRO_NOME",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_CPF@">CPF</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CPF@",
                campo: "CPF",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_NACIONALIDADE@">NACIONALIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NACIONALIDADE@",
                campo: "NACIONALIDADE",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DT_NASCIMENTO@">DATA_NASCIMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_NASCIMENTO@",
                campo: "DATA_NASCIMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_RG@">NR_RG</a>',
                parametro: "@TB_CMCRM_CONTA.NR_RG@",
                campo: "NR_RG",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_RG_ORGAO_EMISSOR@">ORGAO_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_ORGAO_EMISSOR@",
                campo: "ORGAO_EMISSOR",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_RG_UF_EMISSOR@">UF_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_UF_EMISSOR@",
                campo: "UF_EMISSOR",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_ESTADO_CIVIL@">ESTADO_CIVIL</a>',
                parametro: "@TB_CMCRM_CONTA.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_PROFISSAO@">PROFISSAO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_PROFISSAO@",
                campo: "PROFISSAO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_LOGRADOURO_COBRANCA@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_LOGRADOURO_COBRANCA@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_ENDERECO_COBRANCA@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTA.NR_ENDERECO_COBRANCA@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_COMPLEMENTO_COBRANCA@">COMPLEMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_COMPLEMENTO_COBRANCA@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_BAIRRO_COBRANCA@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_BAIRRO_COBRANCA@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_CIDADE_COBRANCA@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_CIDADE_COBRANCA@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_SIGLA_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_SIGLA_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_CEP_COBRANCA@">CEP</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CEP_COBRANCA@",
                campo: "CEP",
            },
        ],
    },
    {
        titleHtml: "DADOS DO EMPREENDIMENTO",
        value: 1,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO@">NOME_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO@",
                campo: "NOME_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO_UAU@">NOME_EMP_UAU</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO_UAU@",
                campo: "NOME_EMP_UAU",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_ESTADO@">ESTADO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_ESTADO@",
                campo: "ESTADO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CIDADE@">CIDADE_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CIDADE@",
                campo: "CIDADE_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_BAIRRO@">BAIRRO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_BAIRRO@",
                campo: "BAIRRO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CEP@">CEP_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CEP@",
                campo: "CEP_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_LOGRADOURO@">LOGRADOURO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_LOGRADOURO@",
                campo: "LOGRADOURO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CNPJ@">CNPJ_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CNPJ@",
                campo: "CNPJ_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO_COMP@">PRODUTO_COMPLETO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO_COMP@",
                campo: "PRODUTO_COMPLETO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_MATRICULA_IMOVEL@">MATRICULA_IMOVEL</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_MATRICULA_IMOVEL@",
                campo: "MATRICULA_IMOVEL",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_REGISTRO_INCORPORACAO@">REGISTRO_INCORPORACAO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_REGISTRO_INCORPORACAO@",
                campo: "REGISTRO_INCORPORACAO",
            },
        ],
    },
    {
        titleHtml: "DADOS PROPOSTA FORMA PAGAMENTO",
        value: 1,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_PRO_BONUS@">VL_DEVEDOR_PRO_BONUS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_PRO_BONUS@",
                campo: "VL_DEVEDOR_PRO_BONUS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_PRO@">VL_DEVEDOR_PRO</a>',
                parametro: "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_PRO@",
                campo: "VL_DEVEDOR_PRO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_BONUS@">VL_DEVEDOR_BONUS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_BONUS@",
                campo: "VL_DEVEDOR_BONUS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_COMPLETO@">VL_DEVEDOR_COMPLETO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_COMPLETO@",
                campo: "VL_DEVEDOR_COMPLETO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_TOTAL_A_RECEBER@">VL_TOTAL_A_RECEBER</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_TOTAL_A_RECEBER@",
                campo: "VL_TOTAL_A_RECEBER",
            },
        ],
    },
    {
        titleHtml: "DADOS REPASSE",
        value: 1,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_REPASSE_DADOS.NR_ADITIVO_FINANCIAMENTO@">NR_ADITIVO_FINANCIAMENTO</a>',
                parametro:
                    "@TB_CMCRM_CASO_REPASSE_DADOS.NR_ADITIVO_FINANCIAMENTO@",
                campo: "NR_ADITIVO_FINANCIAMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_REPASSE_DADOS.DT_ASSINATURA_CAIXA@">DT_ASSINATURA_CAIXA</a>',
                parametro: "@TB_CMCRM_CASO_REPASSE_DADOS.DT_ASSINATURA_CAIXA@",
                campo: "DT_ASSINATURA_CAIXA",
            },
        ],
    },
    {
        titleHtml: "DADOS CONTA PRODUTO",
        value: 1,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA_PRODUTO.DT_VENDA@">DT_VENDA</a>',
                parametro: "@TB_CMCRM_CONTA_PRODUTO.DT_VENDA@",
                campo: "DT_COMPRA_VENDA",
            },
        ],
    },
    // Boleto
    {
        titleHtml: "Dados Gerais",
        value: 2,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.DIA@">DIA</a>',
                parametro: "@TB_GERAL.DIA@",
                campo: "DIA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.DATA_COMPLETA@">DATA_COMPLETA</a>',
                parametro: "@TB_GERAL.DATA_COMPLETA@",
                campo: "DATA_COMPLETA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.USUARIO_LOGADO@">USUARIO_LOGADO</a>',
                parametro: "@TB_GERAL.USUARIO_LOGADO@",
                campo: "USUARIO_LOGADO",
            },
        ],
    },
    {
        titleHtml: "DADOS DO CLIENTE",
        value: 2,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Dia de Geração do Contrato" value="@TB_CMCRM_CONTA.DS_NOME@">NOME</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME@",
                campo: "NOME",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_NOME_1@">PRIMEIRO_NOME</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME_1@",
                campo: "PRIMEIRO_NOME",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_CPF@">CPF</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CPF@",
                campo: "CPF",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_NACIONALIDADE@">NACIONALIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NACIONALIDADE@",
                campo: "NACIONALIDADE",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DT_NASCIMENTO@">DATA_NASCIMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_NASCIMENTO@",
                campo: "DATA_NASCIMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_RG@">NR_RG</a>',
                parametro: "@TB_CMCRM_CONTA.NR_RG@",
                campo: "NR_RG",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_RG_ORGAO_EMISSOR@">ORGAO_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_ORGAO_EMISSOR@",
                campo: "ORGAO_EMISSOR",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_RG_UF_EMISSOR@">UF_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_UF_EMISSOR@",
                campo: "UF_EMISSOR",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_ESTADO_CIVIL@">ESTADO_CIVIL</a>',
                parametro: "@TB_CMCRM_CONTA.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_PROFISSAO@">PROFISSAO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_PROFISSAO@",
                campo: "PROFISSAO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_LOGRADOURO_COBRANCA@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_LOGRADOURO_COBRANCA@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_ENDERECO_COBRANCA@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTA.NR_ENDERECO_COBRANCA@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_COMPLEMENTO_COBRANCA@">COMPLEMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_COMPLEMENTO_COBRANCA@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_BAIRRO_COBRANCA@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_BAIRRO_COBRANCA@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_CIDADE_COBRANCA@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_CIDADE_COBRANCA@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_SIGLA_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_SIGLA_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_CEP_COBRANCA@">CEP</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CEP_COBRANCA@",
                campo: "CEP",
            },
        ],
    },
    {
        titleHtml: "DADOS DO EMPREENDIMENTO",
        value: 2,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO@">NOME_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO@",
                campo: "NOME_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO_UAU@">NOME_EMP_UAU</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO_UAU@",
                campo: "NOME_EMP_UAU",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_ESTADO@">ESTADO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_ESTADO@",
                campo: "ESTADO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CIDADE@">CIDADE_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CIDADE@",
                campo: "CIDADE_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_BAIRRO@">BAIRRO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_BAIRRO@",
                campo: "BAIRRO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CEP@">CEP_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CEP@",
                campo: "CEP_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_LOGRADOURO@">LOGRADOURO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_LOGRADOURO@",
                campo: "LOGRADOURO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CNPJ@">CNPJ_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CNPJ@",
                campo: "CNPJ_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO_COMP@">PRODUTO_COMPLETO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO_COMP@",
                campo: "PRODUTO_COMPLETO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_MATRICULA_IMOVEL@">MATRICULA_IMOVEL</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_MATRICULA_IMOVEL@",
                campo: "MATRICULA_IMOVEL",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_REGISTRO_INCORPORACAO@">REGISTRO_INCORPORACAO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_REGISTRO_INCORPORACAO@",
                campo: "REGISTRO_INCORPORACAO",
            },
        ],
    },
    {
        titleHtml: "DADOS INADIMPLÊNCIA - PARCELAS",
        value: 2,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.DT_VENCIMENTO@">DATA_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.DT_VENCIMENTO@",
                campo: "DATA_VENCIMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.VL_PARCELA@">VALOR_PARCELA</a>',
                parametro: "@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.VL_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.DS_LINHA_DIGITAVEL@">LINHA_DIGITAVEL</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.DS_LINHA_DIGITAVEL@",
                campo: "LINHA_DIGITAVEL",
            },
        ],
    },
    {
        titleHtml: "UTILITÁRIOS",
        value: 2,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@UTILITARIOS.NAO_RECEBER_COBRANCA@">NAO_RECEBER_COBRANCA</a>',
                parametro: "@UTILITARIOS.NAO_RECEBER_COBRANCA@",
                campo: "NAO_RECEBER_COBRANCA",
            },
        ],
    },
    {
        titleHtml: "RÉGUA - PREVENTIVO",
        value: 2,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.DS_LINHA_DIGITAVEL@">LINHA_DIGITAVEL</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.DS_LINHA_DIGITAVEL@",
                campo: "LINHA_DIGITAVEL",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.VL_PARCELA@">VALOR_PARCELA</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.VL_PARCELA@",
                campo: "VALOR_PARCELA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@FL_LIDO_EMAIL@">FL_LIDO_EMAIL</a>',
                parametro: "@FL_LIDO_EMAIL@",
                campo: "FL_LIDO_EMAIL",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.DT_VENCIMENTO@">DATA_VENCIMENTO</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.DT_VENCIMENTO@",
                campo: "DATA_VENCIMENTO",
            },
        ],
    },

    // Cobrança

    {
        titleHtml: "Dados Gerais",
        value: 3,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.DIA@">DIA</a>',
                parametro: "@TB_GERAL.DIA@",
                campo: "DIA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.DATA_COMPLETA@">DATA_COMPLETA</a>',
                parametro: "@TB_GERAL.DATA_COMPLETA@",
                campo: "DATA_COMPLETA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_GERAL.USUARIO_LOGADO@">USUARIO_LOGADO</a>',
                parametro: "@TB_GERAL.USUARIO_LOGADO@",
                campo: "USUARIO_LOGADO",
            },
        ],
    },
    {
        titleHtml: "DADOS DO CLIENTE",
        value: 3,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Dia de Geração do Contrato" value="@TB_CMCRM_CONTA.DS_NOME@">NOME</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME@",
                campo: "NOME",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_NOME_1@">PRIMEIRO_NOME</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NOME_1@",
                campo: "PRIMEIRO_NOME",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_CPF@">CPF</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CPF@",
                campo: "CPF",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_NACIONALIDADE@">NACIONALIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_NACIONALIDADE@",
                campo: "NACIONALIDADE",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DT_NASCIMENTO@">DATA_NASCIMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DT_NASCIMENTO@",
                campo: "DATA_NASCIMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_RG@">NR_RG</a>',
                parametro: "@TB_CMCRM_CONTA.NR_RG@",
                campo: "NR_RG",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_RG_ORGAO_EMISSOR@">ORGAO_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_ORGAO_EMISSOR@",
                campo: "ORGAO_EMISSOR",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_RG_UF_EMISSOR@">UF_EMISSOR</a>',
                parametro: "@TB_CMCRM_CONTA.DS_RG_UF_EMISSOR@",
                campo: "UF_EMISSOR",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_ESTADO_CIVIL@">ESTADO_CIVIL</a>',
                parametro: "@TB_CMCRM_CONTA.DS_ESTADO_CIVIL@",
                campo: "ESTADO_CIVIL",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_PROFISSAO@">PROFISSAO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_PROFISSAO@",
                campo: "PROFISSAO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_LOGRADOURO_COBRANCA@">ENDERECO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_LOGRADOURO_COBRANCA@",
                campo: "ENDERECO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_ENDERECO_COBRANCA@">NUMERO</a>',
                parametro: "@TB_CMCRM_CONTA.NR_ENDERECO_COBRANCA@",
                campo: "NUMERO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_COMPLEMENTO_COBRANCA@">COMPLEMENTO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_COMPLEMENTO_COBRANCA@",
                campo: "COMPLEMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_BAIRRO_COBRANCA@">BAIRRO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_BAIRRO_COBRANCA@",
                campo: "BAIRRO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_CIDADE_COBRANCA@">CIDADE</a>',
                parametro: "@TB_CMCRM_CONTA.DS_CIDADE_COBRANCA@",
                campo: "CIDADE",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.DS_SIGLA_ESTADO@">ESTADO</a>',
                parametro: "@TB_CMCRM_CONTA.DS_SIGLA_ESTADO@",
                campo: "ESTADO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA.NR_CEP_COBRANCA@">CEP</a>',
                parametro: "@TB_CMCRM_CONTA.NR_CEP_COBRANCA@",
                campo: "CEP",
            },
        ],
    },
    {
        titleHtml: "DADOS DO EMPREENDIMENTO",
        value: 3,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO@">NOME_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO@",
                campo: "NOME_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO_UAU@">NOME_EMP_UAU</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO_UAU@",
                campo: "NOME_EMP_UAU",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_ESTADO@">ESTADO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_ESTADO@",
                campo: "ESTADO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CIDADE@">CIDADE_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CIDADE@",
                campo: "CIDADE_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_BAIRRO@">BAIRRO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_BAIRRO@",
                campo: "BAIRRO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CEP@">CEP_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CEP@",
                campo: "CEP_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_LOGRADOURO@">LOGRADOURO_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_LOGRADOURO@",
                campo: "LOGRADOURO_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_CNPJ@">CNPJ_EMP</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_CNPJ@",
                campo: "CNPJ_EMP",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_PRODUTO_COMP@">PRODUTO_COMPLETO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_PRODUTO_COMP@",
                campo: "PRODUTO_COMPLETO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_MATRICULA_IMOVEL@">MATRICULA_IMOVEL</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_MATRICULA_IMOVEL@",
                campo: "MATRICULA_IMOVEL",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PRODUTO.DS_REGISTRO_INCORPORACAO@">REGISTRO_INCORPORACAO</a>',
                parametro: "@TB_CMCRM_PRODUTO.DS_REGISTRO_INCORPORACAO@",
                campo: "REGISTRO_INCORPORACAO",
            },
        ],
    },
    {
        titleHtml: "DADOS DO CASO",
        value: 3,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO.ID_CASO@">NUM_CASO</a>',
                parametro: "@TB_CMCRM_CASO.ID_CASO@",
                campo: "NUM_CASO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO.DS_CASO@">DESCRICAO_CASO</a>',
                parametro: "@TB_CMCRM_CASO.DS_CASO@",
                campo: "DESCRICAO_CASO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO.DS_CASO_SEM_HTML@">DESCRICAO_CASO_SEM_HTML</a>',
                parametro: "@TB_CMCRM_CASO.DS_CASO_SEM_HTML@",
                campo: "DESCRICAO_CASO_SEM_HTML",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO.DS_CASO_SEM_HTML_CURTO@">DESCRICAO_CASO_SEM_HTML_CURTO</a>',
                parametro: "@TB_CMCRM_CASO.DS_CASO_SEM_HTML_CURTO@",
                campo: "DESCRICAO_CASO_SEM_HTML_CURTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO.DT_INICIO@">DATA_INICIO</a>',
                parametro: "@TB_CMCRM_CASO.DT_INICIO@",
                campo: "DATA_INICIO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA_PRODUTO.DT_VENDA@">DATA_CONTRATO</a>',
                parametro: "@TB_CMCRM_CONTA_PRODUTO.DT_VENDA@",
                campo: "DATA_CONTRATO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA_PRODUTO.DS_PRODUTO@">UNIDADE</a>',
                parametro: "@TB_CMCRM_CONTA_PRODUTO.DS_PRODUTO@",
                campo: "UNIDADE",
            },
        ],
    },
    {
        titleHtml: "DADOS INADIMPLÊNCIA - PARCELAS",
        value: 3,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.LISTA@">LISTA_PARCELAS_VENCIDAS</a>',
                parametro: "@TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.LISTA@",
                campo: "LISTA_PARCELAS_VENCIDAS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@LISTA_PARCELAS_UAU.DT_PRORROGACAO@">DATA_PRORROGACAO</a>',
                parametro: "@LISTA_PARCELAS_UAU.DT_PRORROGACAO@",
                campo: "DATA_PRORROGACAO",
            },
        ],
    },
    {
        titleHtml: "DADOS PROPOSTA FORMA PAGAMENTO",
        value: 3,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_PRO_BONUS@">VL_DEVEDOR_PRO_BONUS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_PRO_BONUS@",
                campo: "VL_DEVEDOR_PRO_BONUS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_PRO@">VL_DEVEDOR_PRO</a>',
                parametro: "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_PRO@",
                campo: "VL_DEVEDOR_PRO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_BONUS@">VL_DEVEDOR_BONUS</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_BONUS@",
                campo: "VL_DEVEDOR_BONUS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_COMPLETO@">VL_DEVEDOR_COMPLETO</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_DEVEDOR_COMPLETO@",
                campo: "VL_DEVEDOR_COMPLETO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_TOTAL_A_RECEBER@">VL_TOTAL_A_RECEBER</a>',
                parametro:
                    "@TB_CMCRM_PROPOSTA_FORMA_PAGAMENTO.VL_TOTAL_A_RECEBER@",
                campo: "VL_TOTAL_A_RECEBER",
            },
        ],
    },
    {
        titleHtml: "DADOS REPASSE",
        value: 3,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_REPASSE_DADOS.NR_ADITIVO_FINANCIAMENTO@">NR_ADITIVO_FINANCIAMENTO</a>',
                parametro:
                    "@TB_CMCRM_CASO_REPASSE_DADOS.NR_ADITIVO_FINANCIAMENTO@",
                campo: "NR_ADITIVO_FINANCIAMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_REPASSE_DADOS.DT_ASSINATURA_CAIXA@">DT_ASSINATURA_CAIXA</a>',
                parametro: "@TB_CMCRM_CASO_REPASSE_DADOS.DT_ASSINATURA_CAIXA@",
                campo: "DT_ASSINATURA_CAIXA",
            },
        ],
    },
    {
        titleHtml: "DADOS CONTA PRODUTO",
        value: 3,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA_PRODUTO.DT_VENDA@">DT_VENDA</a>',
                parametro: "@TB_CMCRM_CONTA_PRODUTO.DT_VENDA@",
                campo: "DT_COMPRA_VENDA",
            },
        ],
    },

    {
        titleHtml: "DADOS DA RENEGOCIAÇÃO",
        value: 3,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_LISTA_PARCELAS_RENEGOCIADAS.LISTA@">LISTA_PARCELAS_RENEGOCIADAS</a>',
                parametro: "@TB_LISTA_PARCELAS_RENEGOCIADAS.LISTA@",
                campo: "LISTA_PARCELAS_RENEGOCIADAS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_LISTA_PARCELAS_RENEGOCIADAS.LISTA_CASO@">LISTA_PARCELAS_CASO_RENEGOCIADAS</a>',
                parametro: "@TB_LISTA_PARCELAS_RENEGOCIADAS.LISTA_CASO@",
                campo: "LISTA_PARCELAS_CASO_RENEGOCIADAS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_LISTA_PARCELAS_RENEGOCIADAS.LISTA_ORIGINAIS@">LISTA_PARCELAS_ORIGINAIS</a>',
                parametro: "@TB_LISTA_PARCELAS_RENEGOCIADAS.LISTA_ORIGINAIS@",
                campo: "LISTA_PARCELAS_ORIGINAIS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_LISTA_PARCELAS_RENEGOCIADAS.LISTA_GERADAS@">LISTA_PARCELAS_GERADAS</a>',
                parametro: "@TB_LISTA_PARCELAS_RENEGOCIADAS.LISTA_GERADAS@",
                campo: "LISTA_PARCELAS_GERADAS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CONTA_PRODUTO.DT_VENDA@">DATA_VENDA</a>',
                parametro: "@TB_CMCRM_CONTA_PRODUTO.DT_VENDA@",
                campo: "DATA_VENDA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_LISTA_PARCELAS_RENEGOCIADAS.DATA_VENCIMENTO_1_PARCELA@">DATA_VENCIMENTO_1_PARCELA</a>',
                parametro:
                    "@TB_LISTA_PARCELAS_RENEGOCIADAS.DATA_VENCIMENTO_1_PARCELA@",
                campo: "DATA_VENCIMENTO_1_PARCELA",
            },

            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.DT_INICIO_NEGOCIACAO@">DT_NEGOCIACAO</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.DT_INICIO_NEGOCIACAO@",
                campo: "DT_NEGOCIACAO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.VL_TOTAL_NEGOCIADO@">VALOR_TOTAL_NEGOCIADO</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.VL_TOTAL_NEGOCIADO@",
                campo: "VALOR_TOTAL_NEGOCIADO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.DS_VL_TOTAL_NEGOCIADO@">VALOR_EXTENSO_TOTAL_NEGOCIADO</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.DS_VL_TOTAL_NEGOCIADO@",
                campo: "VALOR_EXTENSO_TOTAL_NEGOCIADO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_LISTA_PARCELAS_RENEGOCIADAS.NUMERO_PARCELA@">NUMERO_PARCELA</a>',
                parametro: "@TB_LISTA_PARCELAS_RENEGOCIADAS.NUMERO_PARCELA@",
                campo: "NUMERO_PARCELA",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_LISTA_PARCELAS_RENEGOCIADAS.NUMERO_PARCELA_EXTENSO@">NUMERO_PARCELA_EXTENSO</a>',
                parametro:
                    "@TB_LISTA_PARCELAS_RENEGOCIADAS.NUMERO_PARCELA_EXTENSO@",
                campo: "NUMERO_PARCELA_EXTENSO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.VL_TOTAL_FINANCIAMENTO@">VL_TOTAL_FINANCIAMENTO</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.VL_TOTAL_FINANCIAMENTO@",
                campo: "VL_TOTAL_FINANCIAMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.DS_VL_TOTAL_FINANCIAMENTO@">DS_VL_TOTAL_FINANCIAMENTO</a>',
                parametro:
                    "@TB_CMCRM_CASO_COBRANCA_NEGOCIACAO.DS_VL_TOTAL_FINANCIAMENTO@",
                campo: "DS_VL_TOTAL_FINANCIAMENTO",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" value="@TB_CMCRM_CASO_COBRANCA_DADOS.ID_VENDA@">NUM_VENDA</a>',
                parametro: "@TB_CMCRM_CASO_COBRANCA_DADOS.ID_VENDA@",
                campo: "NUM_VENDA",
            },
        ],
    },

    {
        titleHtml: "Dados Vendedores",
        repeticao: true,
        organizacoes: ["8B62E38E-8FF4-42CA-B567-E3EC7D9896D0"],
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Vendedor" value="@UTIL.UAU.VENDEDOR.INICIO@">INICIO_VENDEDOR</a>',
                parametro: "@UTIL.UAU.VENDEDOR.INICIO@",
                campo: "INICIO_VENDEDOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Vendedor" value="@UTIL.UAU.VENDEDOR.FIM@">FIM_VENDEDOR</a>',
                parametro: "@UTIL.UAU.VENDEDOR.FIM@",
                campo: "FIM_VENDEDOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Vendedor Completo" value="@UAU.VENDEDOR.DS_NOME_VENDEDOR_COMPLETO@">NOME_VENDEDOR_COMPLETO</a>',
                parametro: "@UAU.VENDEDOR.DS_NOME_VENDEDOR_COMPLETO@",
                campo: "NOME_VENDEDOR_COMPLETO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Vendedor" value="@UAU.VENDEDOR.DS_NOME_VENDEDOR@">NOME_VENDEDOR</a>',
                parametro: "@UAU.VENDEDOR.DS_NOME_VENDEDOR@",
                campo: "NOME_VENDEDOR",
            },
        ],
    },
    {
        titleHtml: "Dados Credores Fiduciários",
        repeticao: true,
        organizacoes: ["8B62E38E-8FF4-42CA-B567-E3EC7D9896D0"],
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Início dos dados do Credor Fiduciário" value="@UTIL.UAU.CREDOR.INICIO@">INICIO_CREDOR</a>',
                parametro: "@UTIL.UAU.CREDOR.INICIO@",
                campo: "INICIO_CREDOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marcador de Fim dos dados do Credor Fiduciário" value="@UTIL.UAU.CREDOR.FIM@">FIM_CREDOR</a>',
                parametro: "@UTIL.UAU.CREDOR.FIM@",
                campo: "FIM_CREDOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Credor Fiduciário Completo" value="@UAU.CREDOR.DS_NOME_CREDOR_FIDUCIARIO_COMPLETO@">NOME_CREDOR_FIDUCIARIO_COMPLETO</a>',
                parametro: "@UAU.CREDOR.DS_NOME_CREDOR_FIDUCIARIO_COMPLETO@",
                campo: "NOME_CREDOR_FIDUCIARIO_COMPLETO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome do Credor Fiduciário" value="@UAU.CREDOR.DS_NOME_CREDOR_FIDUCIARIO@">NOME_CREDOR_FIDUCIARIO</a>',
                parametro: "@UAU.CREDOR.DS_NOME_CREDOR_FIDUCIARIO@",
                campo: "NOME_CREDOR_FIDUCIARIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Percentual do Credor Fiduciário" value="@UAU.CREDOR.VL_PERCENTUAL_CREDOR_FIDUCIARIO@">%_CREDOR_FIDUCIARIO</a>',
                parametro: "@UAU.CREDOR.VL_PERCENTUAL_CREDOR_FIDUCIARIO@",
                campo: "%_CREDOR_FIDUCIARIO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Assinatura do Credor Fiduciário" value="@UAU.CREDOR.DS_ASSINATURA_CREDOR_FIDUCIARIO@">ASSINATURA_CREDOR_FIDUCIARIO</a>',
                parametro: "@UAU.CREDOR.DS_ASSINATURA_CREDOR_FIDUCIARIO@",
                campo: "ASSINATURA_CREDOR_FIDUCIARIO",
            },
        ],
    },
    {
        titleHtml: "Utilitários",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marca o Início de uma Repetição" value="@REPETIDOR.INICIO@">INICIO_REPETIDOR</a>',
                parametro: "@REPETIDOR.INICIO@",
                campo: "INICIO_REPETIDOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marca o Fim de uma Repetição" value="@REPETIDOR.FIM@">FIM_REPETIDOR</a>',
                parametro: "@REPETIDOR.FIM@",
                campo: "FIM_REPETIDOR",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marca o Início de uma Repetição Interna" value="@REPETIDOR.INTERNO.INICIO@">INICIO_REPETIDOR_INTERNO</a>',
                parametro: "@REPETIDOR.INTERNO.INICIO@",
                campo: "INICIO_REPETIDOR_INTERNO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marca o Fim de uma Repetição Interna" value="@REPETIDOR.INTERNO.FIM@">FIM_REPETIDOR_INTERNO</a>',
                parametro: "@REPETIDOR.INTERNO.FIM@",
                campo: "FIM_REPETIDOR_INTERNO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Oculta a Linha de uma Tabela" value="@OCULTAR.LINHA@">OCULTAR_LINHA</a>',
                parametro: "@OCULTAR.LINHA@",
                campo: "OCULTAR_LINHA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marca o Início de um Valor Monetário por Extenso" value="@EXTENSO.INICIO@">INICIO_R$_EXTENSO</a>',
                parametro: "@EXTENSO.INICIO@",
                campo: "INICIO_R$_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marca o Fim de um Valor por Monetário Extenso" value="@EXTENSO.FIM@">FIM_R$_EXTENSO</a>',
                parametro: "@EXTENSO.FIM@",
                campo: "FIM_R$_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marca o Início de um Valor Numérico por Extenso" value="@EXTENSO_NUM.INICIO@">INICIO_NUM_EXTENSO</a>',
                parametro: "@EXTENSO_NUM.INICIO@",
                campo: "INICIO_NUM_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Marca o Fim de um Valor Numérico por Extenso" value="@EXTENSO_NUM.FIM@">FIM_NUM_EXTENSO</a>',
                parametro: "@EXTENSO_NUM.FIM@",
                campo: "FIM_NUM_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Quebra a Página Atual" value="@QUEBRAPAGINA@">QUEBRA_PAGINA</a>',
                parametro: "@QUEBRAPAGINA@",
                campo: "QUEBRA_PAGINA",
            },
        ],
    },
    {
        titleHtml: "Renegociação",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Ultimo fluxo de pagamento cadastrado no Capys" value="@RENEGOCIACAO.FLUXO_ANTIGO@">FLUXO_ANTIGO</a>',
                parametro: "@RENEGOCIACAO.FLUXO_ANTIGO@",
                campo: "FLUXO_ANTIGO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Novo Fluxo de Pagamento Cadastrado no Capys" value="@RENEGOCIACAO.FLUXO_NOVO@">FLUXO_NOVO</a>',
                parametro: "@RENEGOCIACAO.FLUXO_NOVO@",
                campo: "FLUXO_NOVO",
            },
        ],
    },
    {
        titleHtml: "Informações de Venda",
        value: 4,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data da Venda" value="@TB_CMCRM_PRODUTO.INFOR_VENDAS.DT_VENDA@">DT_VENDA</a>',
                parametro: "@TB_CMCRM_PRODUTO.INFOR_VENDAS.DT_VENDA@",
                campo: "DT_VENDA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Chave ERP" value="@TB_CMCRM_PRODUTO.INFOR_VENDAS.ID_CHAVE_ERP_VENDA@">ID_CHAVE_ERP_VENDA</a>',
                parametro: "@TB_CMCRM_PRODUTO.INFOR_VENDAS.ID_CHAVE_ERP_VENDA@",
                campo: "ID_CHAVE_ERP_VENDA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total de Parcelas Recebidas" value="@TB_CMCRM_PRODUTO.INFOR_VENDAS.VL_TOTAL_RECEBIDAS@">VL_TOTAL_RECEBIDAS</a>',
                parametro: "@TB_CMCRM_PRODUTO.INFOR_VENDAS.VL_TOTAL_RECEBIDAS@",
                campo: "VL_TOTAL_RECEBIDAS",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor Total de Parcelas a Receber" value="@TB_CMCRM_PRODUTO.INFOR_VENDAS.VL_TOTAL_RECEBER@">VL_TOTAL_RECEBER</a>',
                parametro: "@TB_CMCRM_PRODUTO.INFOR_VENDAS.VL_TOTAL_RECEBER@",
                campo: "VL_TOTAL_RECEBER",
            },
        ],
    },
    {
        titleHtml: "Informações de Email de Agendamento",
        value: 5,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome Técnico" value="@EMAIL.AGENDAMENTO.DS_NOME_TECNICO@">DS_NOME_TECNICO</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_NOME_TECNICO@",
                campo: "DS_NOME_TECNICO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="CPF Técnico" value="@EMAIL.AGENDAMENTO.DS_CPF_TECNICO@">DS_CPF_TECNICO</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_CPF_TECNICO@",
                campo: "DS_CPF_TECNICO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="RG Técnico" value="@EMAIL.AGENDAMENTO.DS_RG_TECNICO@">DS_RG_TECNICO</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_RG_TECNICO@",
                campo: "DS_RG_TECNICO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Nome Cliente" value="@EMAIL.AGENDAMENTO.DS_NOME_CLIENTE@">DS_NOME_CLIENTE</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_NOME_CLIENTE@",
                campo: "DS_NOME_CLIENTE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="ID Caso" value="@EMAIL.AGENDAMENTO.ID_CASO@">ID_CASO</a>',
                parametro: "@EMAIL.AGENDAMENTO.ID_CASO@",
                campo: "ID_CASO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Empreendimento" value="@EMAIL.AGENDAMENTO.DS_EMPREENDIMENTO@">DS_EMPREENDIMENTO</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_EMPREENDIMENTO@",
                campo: "DS_EMPREENDIMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Unidade" value="@EMAIL.AGENDAMENTO.DS_UNIDADE@">DS_UNIDADE</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_UNIDADE@",
                campo: "DS_UNIDADE",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Etapa" value="@EMAIL.AGENDAMENTO.DS_ETAPA@">DS_ETAPA</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_ETAPA@",
                campo: "DS_ETAPA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Categoria" value="@EMAIL.AGENDAMENTO.DS_CATEGORIA@">DS_CATEGORIA</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_CATEGORIA@",
                campo: "DS_CATEGORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data Horário Vistoria" value="@EMAIL.AGENDAMENTO.DT_HORARIO_VISTORIA@">DT_HORARIO_VISTORIA</a>',
                parametro: "@EMAIL.AGENDAMENTO.DT_HORARIO_VISTORIA@",
                campo: "DT_HORARIO_VISTORIA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Data Horário Vistoria" value="@EMAIL.AGENDAMENTO.DS_LINK_AGENDAMENTO@">DS_LINK_AGENDAMENTO</a>',
                parametro: "@EMAIL.AGENDAMENTO.DS_LINK_AGENDAMENTO@",
                campo: "DS_LINK_AGENDAMENTO",
            },
        ],
    },
    {
        titleHtml: "Informação Integração UAU",
        value: 6,
        atributos: [
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" title="Tabela com a lista de parcelas em aberto dentro do UAU" value="@LISTA_PARCELAS_UAU@">LISTA_PARCELAS</a>',
                parametro: "@LISTA_PARCELAS_UAU@",
                campo: "LISTA_PARCELAS",
            },
            {
                html: '<a href="#/cadastro/cadTemplateDocumento" class="atributosTemplate" title="Tabela com a lista de parcelas em aberto dentro do UAU sem as parcelas de financiamento" value="@LISTA_PARCELAS_UAU_SEM_FINANCIAMENTO@">LISTA_PARCELAS_SEM_FINANCIAMENTO</a>',
                parametro: "@LISTA_PARCELAS_UAU_SEM_FINANCIAMENTO@",
                campo: "LISTA_PARCELAS_SEM_FINANCIAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor do Saldo Devedor Atualizado da Venda no UAU" value="@SALDO_DEVERDOR_UAU@">SALDO_DEVEDOR_VENDA</a>',
                parametro: "@SALDO_DEVERDOR_UAU@",
                campo: "SALDO_DEVEDOR_VENDA",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor do Saldo Devedor Atualizado da Venda no UAU por extenso" value="@SALDO_DEVERDOR_UAU_EXTENSO@">SALDO_DEVEDOR_VENDA_EXTENSO</a>',
                parametro: "@SALDO_DEVERDOR_UAU_EXTENSO@",
                campo: "SALDO_DEVEDOR_VENDA_EXTENSO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor do Saldo Devedor Atualizado da Venda no UAU sem valores de financiamento" value="@SALDO_DEVERDOR_UAU_SEM_FINANCIAMENTO@">SALDO_DEVEDOR_VENDA_SEM_FINANCIAMENTO</a>',
                parametro: "@SALDO_DEVERDOR_UAU_SEM_FINANCIAMENTO@",
                campo: "SALDO_DEVEDOR_VENDA_SEM_FINANCIAMENTO",
            },
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Valor do Saldo Devedor Atualizado da Venda no UAU sem valores de financiamento por extenso" value="@SALDO_DEVERDOR_UAU_SEM_FINANCIAMENTO_EXTENSO@">SALDO_DEVEDOR_VENDA_SEM_FINANCIAMENTO_EXTENSO</a>',
                parametro: "@SALDO_DEVERDOR_UAU_SEM_FINANCIAMENTO_EXTENSO@",
                campo: "SALDO_DEVEDOR_VENDA_SEM_FINANCIAMENTO_EXTENSO",
            },
        ],
    },
    {
        titleHtml: "Vistoria",
        value: 7,
        atributos: [
            {
                html: '<a href="#/documento/templates/template" class="atributosTemplate" title="Comentário feito na vistoria conforme ou não conforme" value="@VISTORIA.RESPOSTA.DS_COMENTARIO@">DS_COMENTARIO</a>',
                parametro: "@VISTORIA.RESPOSTA.DS_COMENTARIO@",
                campo: "DS_COMENTARIO",
            },
        ],
    },
];
